<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    style="overflow-y: hidden;"
  >
    <v-card class="pa-5">
      <v-card-title class="px-5">
        <v-row>
          <v-spacer></v-spacer>
          <v-btn fab text x-small color="#00A99D" @click="closeDialog()">
            <v-icon >mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>

      <v-card-text class="py-3 pb-8 px-10" v-if="status !== 'detail'">
        <v-form ref="form">
          <v-row class="pb-3 baseline">
            <span class="mr-2 font-16 text-000000 w-600">ชุมชน</span>
            <v-text-field
              dense
              solo
              hide-details="auto"
              v-model="data.community_name"
              :rules="status == 'see' ? [] : rules_input"
              :readonly="status == 'see'"
            >
              <template slot="label">
                <span class="font-14">กรุณากรอกชื่อชุมชน</span>
              </template>
            </v-text-field>
          </v-row>
          <v-row class="pb-3 baseline">
            <span class="mr-2 font-16 text-000000 w-600">บ้านเลขที่</span>
            <v-text-field
              v-if="data.house_no || status == 'see'"
              dense
              solo
              hide-details="auto"
              v-model="data.house_no"
              :rules="status == 'see' ? [] : rules_input"
              :readonly="status == 'see'"
              :disabled="data.house_no ? true : false"
            >
              <template slot="label">
                <span class="font-14">กรุณากรอกบ้านเลขที่</span>
              </template>
            </v-text-field>
            <v-col v-else cols="12" class="d-flex d-flex-row">
              <v-row no-gutters>
                <v-card class="pa-8">
                  <v-row>
                    <v-col cols="12" sm="3" md="3" xl="2" lg="2" class="pt-0">
                    <div class="d-flex flex-column">
                      <span class="text-333333"> บ้านเลขที่</span>
                        <v-text-field
                          placeholder="บ้านเลขที่"
                          solo
                          hide-details="auto"
                          dense
                          v-model="data.data_addressable.house_no"
                          :rules="rules_input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" xl="2" lg="2" class="pt-0">
                      <div class="d-flex flex-column">
                        <span class="text-333333"> หมู่ </span>
                        <v-text-field
                          placeholder="หมู่"
                          solo
                          hide-details="auto"
                          v-model="data.data_addressable.moo_no"
                          dense
                          :rules="rules_input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="pt-0">
                      <div class="d-flex flex-column">
                        <span class="text-333333"> ถนน / ซอย </span>
                        <v-text-field
                          placeholder="ถนน / ซอย"
                          solo
                          hide-details="auto"
                          v-model="data.data_addressable.soi"
                          dense
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="pt-0">
                      <div class="d-flex flex-column">
                        <span class="text-333333"> จังหวัด </span>
                        <v-autocomplete
                          :items="set_province"
                          item-value="province"
                          item-text="province"
                          @input="getProvince('addressable'), getAmphoe('addressable')"
                          :menu-props="{ bottom: true, offsetY: true }"
                          solo
                          dense
                          hide-details="auto"
                          placeholder="กรุณาเลือกจังหวัด"
                          v-model="data.data_addressable.province"
                          item-color="teal darken-2"
                          color="#00A99D"
                          :rules="rules_input"
                        >
                          <template slot="no-data">
                            <span class="pl-2">ไม่มีข้อมูลจังหวัด</span>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="pt-0">
                      <div class="d-flex flex-column">
                        <span class="text-333333"> อำเภอ / เขต </span>
                        <v-autocomplete
                          :items="set_amphoe"
                          item-value="amphoe"
                          item-text="amphoe"
                          @input="getTambon('addressable')"
                          :menu-props="{ bottom: true, offsetY: true }"
                          solo
                          dense
                          hide-details="auto"
                          placeholder="กรุณาเลือกอำเภอ/เขต"
                          v-model="data.data_addressable.amphur"
                          item-color="teal darken-2"
                          color="#00A99D"
                          :rules="rules_input"
                        >
                          <template slot="no-data">
                            <span class="pl-2">กรุณาเลือกจังหวัด</span>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="pt-0">
                      <div class="d-flex flex-column">
                        <span class="text-333333"> ตำบล / แขวง </span>
                        <v-autocomplete
                          :items="set_tambon"
                          item-value="tambon"
                          item-text="tambon"
                          @change="getPostal($event, 'addressable')"
                          :menu-props="{ bottom: true, offsetY: true }"
                          solo
                          dense
                          hide-details="auto"
                          placeholder="กรุณาเลือกตำบล/แขวง"
                          v-model="data.data_addressable.tambon"
                          item-color="teal darken-2"
                          color="#00A99D"
                          :rules="rules_input"
                        >
                          <template slot="no-data">
                            <span class="pl-2">กรุณาเลือกอำเภอ</span>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="pt-0">
                      <div class="d-flex flex-column">
                        <span class="text-333333">รหัสไปรษณีย์</span>
                        <v-text-field
                          placeholder="รหัสไปรษณีย์"
                          solo
                          hide-details="auto"
                          v-model="data.data_addressable.zipcode"
                          dense
                          :rules="rules_input"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="pb-3 mt-0">
            <v-col cols="12" sm="6" md="6" xl="5" lg="5" class="d-flex baseline" :class="x_mobile ? 'px-0' : 'pl-0'">
              <span class="mr-2 font-16 text-000000 w-600">เลขบัตรประชาชน</span>
              <v-text-field
                dense
                solo
                hide-details="auto"
                v-model="cardnum"
                :rules="status == 'see' ? [] : rules_input"
                :readonly="status == 'see'"
                :disabled="cardnum != ''"
                v-mask="mask_id"
                v-if="data.cid"
              >
                <template slot="label">
                  <span class="font-14">กรุณากรอกเลขบัตรประชาชน</span>
                </template>
              </v-text-field>
              <v-text-field
                dense
                solo
                hide-details="auto"
                v-model="cardnum"
                :rules="status == 'see' ? [] : rules_input"
                :readonly="status == 'see'"
                v-mask="mask_id"
                v-else
              >
                <template slot="label">
                  <span class="font-14">กรุณากรอกเลขบัตรประชาชน</span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" xl="5" lg="5" class="d-flex baseline" :class="x_mobile ? 'px-0 pt-0' : tablet ? 'px-0' : 'pl-0'">
              <span class="mr-2 font-16 text-000000 w-600">ชื่อ-สกุล</span>
              <v-text-field
                dense
                solo
                hide-details="auto"
                v-model="data.fullname"
                :rules="status == 'see' ? [] : rules_input"
                :readonly="status == 'see'"
                :disabled="fullname_status == true"
              >
                <template slot="label">
                  <span class="font-14">กรุณากรอกชื่อ-สกุล</span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex baseline" :class="x_mobile ? 'px-0 pt-0' : tablet ? 'pl-0 pt-0' : 'px-0'">
              <span class="mr-2 font-16 text-000000 w-600">เพศ</span>
              <v-select
                solo
                v-model="data.gender"
                :items="['ชาย', 'หญิง']"
                dense
                color="#00A99D"
                item-color="teal darken-2"
                :menu-props="{ bottom: true, offsetY: true }"
                hide-details="auto"
                :rules="status == 'see' ? [] : rules_select"
                :readonly="status == 'see'"
                @change="data.cervical_cancer.status = null,
                         data.cervical_cancer.answer_title = '',
                         data.cervical_cancer.inspection_location = '',
                         data.cervical_cancer.last_inspection_result = '',
                         $refs.form.resetValidation()"
              >
                <template slot="append">
                  <v-btn text icon>
                    <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <template slot="label">
                  <span class="font-14">กรุณาเลือกเพศ</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex baseline" :class="x_mobile || tablet ? 'px-0 pt-0' : 'pl-0 pt-0'">
              <span class="mr-2 font-16 text-000000 w-600">ว.ด.ป.</span>
              <v-menu
                v-model="day_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="350px"
                min-width="auto"
                bottom
                left
                :disabled="status == 'see'"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    solo
                    dense
                    append-icon="mdi-calendar-multiselect"
                    :value="displayDate()"
                    v-bind="attrs"
                    hide-details
                    v-on="on"
                    color="#00A99D"
                    item-color="teal darken-2"
                    :rules="status == 'see' ? [] : rules_input"
                    :readonly="status == 'see'"
                  >
                    <template slot="append">
                      <v-btn text icon v-on="on">
                        <v-icon color="#00A99D"
                          >mdi-calendar-multiselect</v-icon
                        >
                      </v-btn>
                    </template>

                    <template slot="label">
                      <span class="font-14">วัน/เดือน/ปี เกิด</span>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="data.birth_date"
                  :max="dateNow"
                  no-title
                  scrollable
                  locale="th"
                  @input="day_menu = false"
                  color="#00A99D"
                  ref="picker"
                  :disabled="status == 'see'"
                  :active-picker.sync="activePicker"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="#00A99D" @click="clearDaySelect"
                    >ล้างค่า/clear</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex baseline" :class="x_mobile ? 'px-0 pt-0' : tablet ? 'pr-0 pt-0' : 'pt-0 pl-0'">
              <span class="mr-2 font-16 text-000000 w-600">อายุ</span>
              <v-text-field
                solo
                hide-details="auto"
                :value="calculateAge(data.birth_date)"
                dense
                readonly
              >
                <template slot="label">
                  <span class="font-14">กรุณากรอกอายุ</span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex baseline" :class="x_mobile ? 'px-0 pt-0' : tablet ? 'pl-0 pt-0' : 'pt-0 pl-0'">
              <span class="mr-2 font-16 text-000000 w-600">นน</span>
              <v-text-field
                dense
                solo
                hide-details="auto"
                v-model="data.weight"
                :rules="status == 'see' ? [] : rules_input"
                :readonly="status == 'see'"
              >
                <template slot="label">
                  <span class="font-14">กรุณากรอกน้ำหนัก</span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex baseline" :class="x_mobile || tablet ? 'px-0 pt-0' : 'pt-0 pl-0'">
              <span class="mr-2 font-16 text-000000 w-600">สส</span>
              <v-text-field
                dense
                solo
                hide-details="auto"
                v-model="data.height"
                :rules="status == 'see' ? [] : rules_input"
                :readonly="status == 'see'"
              >
                <template slot="label">
                  <span class="font-14">กรุณากรอกส่วนสูง</span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex" :class="x_mobile ? 'px-0 pt-0' : tablet ? 'pr-0 pt-0' : 'pt-0 pl-0'">
              <v-row class="baseline">
                <v-col cols="auto" class="pr-0 mr-2">
                  <span class="font-16 text-000000 w-600">รอบเอว</span>
                </v-col>
                <v-col class="pl-0">
                  <v-text-field
                    dense
                    solo
                    hide-details="auto"
                    v-model="data.around_waist"
                    :rules="status == 'see' ? [] : rules_input"
                    :readonly="status == 'see'"
                  >
                    <template slot="label">
                      <span class="font-14">กรุณากรอกรอบเอว</span>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex baseline" :class="x_mobile ? 'px-0 pt-0' : tablet ? 'pl-0 pt-0' : 'pt-0 px-0'">
              <span class="mr-2 font-16 text-000000 w-600">Tel</span>
              <v-text-field
                dense
                solo
                hide-details="auto"
                v-model="data.mobile"
                :rules="status == 'see' ? [] : rules_input"
                :readonly="status == 'see'"
                v-mask="[mask_mobile1, mask_mobile2]"
                @input="splitDat2('mobile')"
              >
                <template slot="label">
                  <span class="font-14">กรุณากรอกเบอร์โทรศัพท์</span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="pb-3 mt-0">
            <v-col cols="12" xl="5" lg="5" :class="x_mobile || tablet ? 'px-0 pt-0' : 'pl-0 pt-0'">
              <v-row class="baseline">
                <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" class="pr-0" :class="x_mobile ? 'pb-0' : ''">
                  <span class="font-16 text-000000 pr-0 mr-2"><span class="w-600">โรคประจำตัว</span> DM/HT/DLP/อื่นๆ ระบุ</span>
                </v-col>
                <v-col :class="x_mobile ? 'pt-1' : 'pl-0'">
                  <v-text-field
                    dense
                    solo
                    hide-details="auto"
                    v-model="data.personal_diseases"
                    :rules="status == 'see' ? [] : rules_input"
                    :readonly="status == 'see'"
                  >
                    <template slot="label">
                      <span class="font-14">กรุณากรอกโรคประจำตัว</span>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" xl="3" lg="3" :class="x_mobile || tablet ? 'px-0 pt-0' : 'pl-0 pt-0'">
              <v-row class="baseline">
                <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" class="pr-0" :class="x_mobile ? 'pb-0' : ''">
                  <span class="font-16 text-000000 pr-0 mr-2 w-600">สถานที่รักษา</span>
                </v-col>
                <v-col :class="x_mobile ? 'pt-1' : 'pl-0'">
                  <v-text-field
                    dense
                    solo
                    hide-details="auto"
                    v-model="data.treatment_location"
                    :rules="status == 'see' ? [] : rules_input"
                    :readonly="status == 'see'"
                  >
                    <template slot="label">
                      <span class="font-14">กรุณากรอกสถานที่รักษา</span>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" xl="4" lg="4" class="d-flex" align-self="center" :class="x_mobile || tablet ? 'px-0 pt-0' : 'pl-0 pt-0'">
              <span class="font-16 text-000000"><span class="w-600">ความเสี่ยง:</span> รอยพับคอรักแร้ดำ /LDL&lt;50mg&lt; IFG</span>
            </v-col>
          </v-row>
          <v-row class="pb-3 mt-0">
            <v-col cols="12" xl="6" lg="6" :class="x_mobile || tablet ? 'px-0 pt-0' : 'pl-0 pt-0'">
              <v-row class="baseline">
                <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" class="pr-0" :class="x_mobile ? 'pb-0' : ''">
                  <span class="font-16 text-000000 pr-0 mr-2"><span class="w-600">ญาติ</span> ผู้ดูแล(กรณีผส./ผู้มีภาวะพึ่งพิง)</span>
                </v-col>
                <v-col :class="x_mobile ? 'pt-1' : 'pl-0'">
                  <v-text-field
                    dense
                    solo
                    hide-details="auto"
                    v-model="data.caretaker_name"
                    :rules="status == 'see' ? [] : rules_input"
                    :readonly="status == 'see'"
                  >
                    <template slot="label">
                      <span class="font-14">กรุณากรอกญาติ ผู้ดูแล</span>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" xl="6" lg="6" class="d-flex" align-self="center" :class="x_mobile || tablet ? 'px-0 pt-0' : 'pl-0 pt-0'">
              <span class="font-16 text-000000"><span class="w-600">ประวัติครอบครัว</span>  DM /HT /CVD</span>
            </v-col>
          </v-row>
          <v-row class="pb-3 mt-0">
            <v-col class="box">
              <v-row>
                <v-col>
                  <span class="font-16 text-000000 w-600"><u>คัดกรองความเสี่ยงโรคเบาหวานและโรคความดันโลหิตสูง อายุ 35 ปีขึ้นไป</u></span>
                </v-col>
              </v-row>
              <v-row class="mt-0">
                <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex">
                  <v-row class="baseline">
                    <v-col cols="auto" class="pr-0">
                      <span class="mr-2 font-16 text-000000"><span class="w-600"><u>BP:</u></span> ครั้งที่ 1</span>
                    </v-col>
                    <v-col :class="x_mobile ? 'pl-0' : 'px-0'">
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.screening_risk_over35.BP1"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex" :class="x_mobile ? 'pt-0' : ''">
                  <v-row class="baseline">
                    <v-col cols="auto" class="pr-0">
                      <span class="mr-2 font-16 text-000000">ครั้งที่ 2</span>
                    </v-col>
                    <v-col :class="x_mobile ? 'pl-0' : 'px-0'">
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.screening_risk_over35.BP2"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex" :class="x_mobile ? 'pt-0' : ''">
                  <v-row class="baseline">
                    <v-col cols="auto" class="pr-0">
                      <span class="mr-2 font-16 text-000000">/ <span class="w-600"><u>CVD Risk</u></span></span>
                    </v-col>
                    <v-col class="px-0">
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.screening_risk_over35.CVD_Risk"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      />
                    </v-col>
                    <v-col cols="auto" :class="x_mobile || tablet ? 'pl-0 ml-2' : 'px-0 ml-2'">
                      <span class="font-16 text-000000">%</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="d-flex" :class="x_mobile || tablet ? 'pt-0' : ''">
                  <v-row class="baseline">
                    <v-col cols="auto" class="pr-0">
                      <span class="mr-2 font-16 text-000000">(คำนวณผ่านเว็บไซต์) / <span class="w-600"><u>DTX:</u></span></span>
                    </v-col>
                    <v-col class="px-0">
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.screening_risk_over35.DTX"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      />
                    </v-col>
                    <v-col cols="auto" :class="x_mobile ? 'pl-0 ml-2' : 'px-0 ml-2'">
                      <span class="font-16 text-000000">mg%</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="2" lg="2" :class="x_mobile ? 'pt-0' : ''">
                  <v-row class="baseline">
                    <v-col cols="auto" :class="x_mobile || tablet ? 'pt-0' : ''">
                      <v-checkbox
                        dense
                        class="mt-0 pt-2"
                        v-model="data.screening_risk_over35.normality.status"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.screening_risk_over35.normality.answer_title = 'ไม่งด'"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ไม่งด</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="auto" :class="x_mobile || tablet ? 'pt-0' : ''">
                      <v-checkbox
                        dense
                        class="mt-0 pt-2"
                        v-model="data.screening_risk_over35.normality.status"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.screening_risk_over35.normality.answer_title = 'งด'"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">งด</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="mt-0">
                <v-col cols="auto">
                  <v-row>
                    <v-col cols="auto pr-0" :class="x_mobile ? 'pb-0' : ''">
                      <span class="mr-2 font-16 text-000000 w-600"><u>สูบบุหรี่:</u></span>
                    </v-col>
                    <v-col class="d-flex px-0">
                      <v-row>
                        <v-col cols="auto" :class="x_mobile ? 'pb-0' : ''">
                          <v-checkbox
                            class="mt-0 pt-0"
                            dense
                            v-model="data.screening_risk_over35.smoking.status"
                            value="0"
                            color="#00A99D"
                            hide-details="auto"
                            @click="data.screening_risk_over35.smoking.answer_title = 'ไม่'"
                            :readonly="status == 'see'"
                            :rules="status == 'see' ? [] : rules_select"
                          >
                            <template v-slot:label>
                              <span class="font-16 text-000000">ไม่</span>
                            </template>
                          </v-checkbox>
                        </v-col>
                        <v-col cols="auto" :class="x_mobile ? 'pb-0' : ''">
                          <v-checkbox
                            class="mt-0 pt-0"
                            dense
                            v-model="data.screening_risk_over35.smoking.status"
                            value="1"
                            color="#00A99D"
                            hide-details="auto"
                            @click="data.screening_risk_over35.smoking.answer_title = 'ครั้งคราว'"
                            :readonly="status == 'see'"
                            :rules="status == 'see' ? [] : rules_select"
                          >
                            <template v-slot:label>
                              <span class="font-16 text-000000">ครั้งคราว</span>
                            </template>
                          </v-checkbox>
                        </v-col>
                        <v-col cols="auto" :class="x_mobile ? 'pb-0' : ''">
                          <v-checkbox
                            class="mt-0 pt-0"
                            dense
                            v-model="data.screening_risk_over35.smoking.status"
                            value="2"
                            color="#00A99D"
                            hide-details="auto"
                            @click="data.screening_risk_over35.smoking.answer_title = 'ทุกวัน'"
                            :readonly="status == 'see'"
                            :rules="status == 'see' ? [] : rules_select"
                          >
                            <template v-slot:label>
                              <span class="font-16 text-000000">ทุกวัน</span>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="auto">
                  <v-row>
                    <v-col cols="auto pr-0" :class="x_mobile ? 'pb-0' : ''">
                      <span class="mr-2 font-16 text-000000 w-600"><u>แอลกอฮอล์:</u></span>
                    </v-col>
                    <v-col class="d-flex px-0 pb-3">
                      <v-row>
                        <v-col cols="auto" :class="x_mobile ? 'pb-0' : ''">
                          <v-checkbox
                            class="mt-0 pt-0"
                            dense
                            v-model="data.screening_risk_over35.alcohol.status"
                            value="0"
                            color="#00A99D"
                            hide-details="auto"
                            @click="data.screening_risk_over35.alcohol.answer_title = 'ไม่'"
                            :readonly="status == 'see'"
                            :rules="status == 'see' ? [] : rules_select"
                          >
                            <template v-slot:label>
                              <span class="font-16 text-000000">ไม่</span>
                            </template>
                          </v-checkbox>
                        </v-col>
                        <v-col cols="auto" :class="x_mobile ? 'pb-0' : ''">
                          <v-checkbox
                            class="mt-0 pt-0"
                            dense
                            v-model="data.screening_risk_over35.alcohol.status"
                            value="1"
                            color="#00A99D"
                            hide-details="auto"
                            @click="data.screening_risk_over35.alcohol.answer_title = 'ครั้งคราว'"
                            :readonly="status == 'see'"
                            :rules="status == 'see' ? [] : rules_select"
                          >
                            <template v-slot:label>
                              <span class="font-16 text-000000">ครั้งคราว</span>
                            </template>
                          </v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                          <v-checkbox
                            class="mt-0 pt-0"
                            dense
                            v-model="data.screening_risk_over35.alcohol.status"
                            value="2"
                            color="#00A99D"
                            hide-details="auto"
                            @click="data.screening_risk_over35.alcohol.answer_title = 'ทุกวัน'"
                            :readonly="status == 'see'"
                            :rules="status == 'see' ? [] : rules_select"
                          >
                            <template v-slot:label>
                              <span class="font-16 text-000000">ทุกวัน</span>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="box mt-0" :class="x_mobile ? 'pb-3' : ''">
            <v-col>
              <v-row>
                <v-col cols="auto" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000 w-600"><u>การคัดกรองโรคซึมเศร้า 2Q :</u></span>
                </v-col>
                <v-col cols="auto" :class="x_mobile || tablet ? '' : 'px-0'">
                  <v-row>
                    <v-col cols="12" sm="auto" md="6" xl="auto" lg="auto" class="pb-0">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.information_depression.status"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.information_depression.answer_title = 'ปกติ (ไม่มีทั้ง 2 ข้อ) 1B0280',
                                $refs.form.resetValidation(),
                                data.information_depression.subanswer_title_1.status = null,
                                data.information_depression.subanswer_title_1.answer_title = '',
                                data.information_depression.subanswer_title_2.status = null,
                                data.information_depression.subanswer_title_2.answer_title = ''"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ปกติ (ไม่มีทั้ง 2 ข้อ) 1B0280</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="6" xl="auto" lg="auto" class="pb-0">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.information_depression.status"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.information_depression.answer_title = 'มีความเสี่ยง (มีข้อใดข้อหนึ่ง) ทำ 9Q 1B0281 (ทดสอบผ่านเว็บไซต์)'
                                $refs.form.resetValidation(),
                                data.information_depression.subanswer_title_1.status = null,
                                data.information_depression.subanswer_title_1.answer_title = '',
                                data.information_depression.subanswer_title_2.status = null,
                                data.information_depression.subanswer_title_2.answer_title = ''"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">มีความเสี่ยง (มีข้อใดข้อหนึ่ง) ทำ 9Q 1B0281 (ทดสอบผ่านเว็บไซต์)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="auto" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000">1.ใน 2 สัปดาห์ รู้สึกหดหู่ เศร้า หรือท้อแท้ สิ้นหวัง</span>
                </v-col>
                <v-col cols="auto" class="pb-0" :class="x_mobile ? '' : 'pl-0'">
                  <v-checkbox
                    class="mt-0 pt-0"
                    dense
                    v-model="data.information_depression.subanswer_title_1.status"
                    value="0"
                    color="#00A99D"
                    hide-details="auto"
                    @click="data.information_depression.subanswer_title_1.answer_title = 'ไม่มี', check_information_depression('subanswer_title_1')"
                    :rules="status == 'see' ? [] : rules_select"
                    :readonly="status == 'see'"
                  >
                    <template v-slot:label>
                      <span class="font-16 text-000000">ไม่มี</span>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="auto" :class="x_mobile ? 'pb-0' : ''">
                  <v-checkbox
                    class="mt-0 pt-0"
                    dense
                    v-model="data.information_depression.subanswer_title_1.status"
                    value="1"
                    color="#00A99D"
                    hide-details="auto"
                    @click="data.information_depression.subanswer_title_1.answer_title = 'มี', check_information_depression('subanswer_title_1')"
                    :rules="status == 'see' ? [] : rules_select"
                    :readonly="status == 'see'"
                  >
                    <template v-slot:label>
                      <span class="font-16 text-000000">มี</span>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row :class="x_mobile ? '' : 'mt-0'">
                <v-col cols="auto" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000">2.ใน 2 สัปดาห์ รู้สึก เบื่อ ทำอะไรก็ไม่เพลิน</span>
                </v-col>
                <v-col cols="auto" class="pb-0" :class="x_mobile ? '' : 'pl-0'">
                  <v-checkbox
                    class="mt-0 pt-0"
                    dense
                    v-model="data.information_depression.subanswer_title_2.status"
                    value="0"
                    color="#00A99D"
                    hide-details="auto"
                    @click="data.information_depression.subanswer_title_2.answer_title = 'ไม่มี', check_information_depression('subanswer_title_2')"
                    :rules="status == 'see' ? [] : rules_select"
                    :readonly="status == 'see'"
                  >
                    <template v-slot:label>
                      <span class="font-16 text-000000">ไม่มี</span>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="auto" :class="x_mobile ? 'pb-0' : ''">
                  <v-checkbox
                    class="mt-0 pt-0"
                    dense
                    v-model="data.information_depression.subanswer_title_2.status"
                    value="1"
                    color="#00A99D"
                    hide-details="auto"
                    @click="data.information_depression.subanswer_title_2.answer_title = 'มี', check_information_depression('subanswer_title_2')"
                    :rules="status == 'see' ? [] : rules_select"
                    :readonly="status == 'see'"
                  >
                    <template v-slot:label>
                      <span class="font-16 text-000000">มี</span>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xl="6" lg="6">
              <v-row>
                <v-col class="box" cols="12">
                  <v-row>
                    <v-col cols="auto" class="pr-0 pb-0">
                      <span class="mr-2 font-16 text-000000 w-600">มะเร็งปากมดลูก(30-60ปี)</span>
                    </v-col>
                    <v-col cols="12" sm="" md="" xl="" lg="" :class="x_mobile ? '' : 'pl-0'">
                      <v-row>
                        <v-col cols="auto" class="pb-0">
                          <v-checkbox
                            class="mt-0 pt-0"
                            dense
                            v-model="data.cervical_cancer.status"
                            value="0"
                            color="#00A99D"
                            hide-details="auto"
                            @click="data.cervical_cancer.answer_title = 'ไม่เคย',
                                    data.cervical_cancer.inspection_location = '',
                                    data.cervical_cancer.last_inspection_result = '',
                                    $refs.form.resetValidation()"
                            :readonly="status == 'see' || data.gender == 'ชาย' || data.gender == ''"
                            :rules="status == 'see' ? [] : rules_select"
                          >
                            <template v-slot:label>
                              <span class="font-16 text-000000">ไม่เคย</span>
                            </template>
                          </v-checkbox>
                        </v-col>
                        <v-col cols="auto" class="pb-0">
                          <v-checkbox
                            class="mt-0 pt-0"
                            dense
                            v-model="data.cervical_cancer.status"
                            value="1"
                            color="#00A99D"
                            hide-details="auto"
                            @click="data.cervical_cancer.answer_title = 'เคย',
                                    data.cervical_cancer.inspection_location = '',
                                    data.cervical_cancer.last_inspection_result = '',
                                    $refs.form.resetValidation()"
                            :readonly="status == 'see' || data.gender == 'ชาย' || data.gender == ''"
                            :rules="status == 'see' ? [] : rules_select"
                          >
                            <template v-slot:label>
                              <span class="font-16 text-000000">เคย</span>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="d-flex baseline pb-0" :class="x_mobile ? '' : 'pr-0'">
                      <span class="mr-2 font-16 text-000000">ที่ตรวจ</span>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.cervical_cancer.inspection_location"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                        :disabled="data.cervical_cancer.status == '0' || data.gender == 'ชาย' || data.gender == ''"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกที่ตรวจ</span>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="d-flex baseline">
                      <span class="mr-2 font-16 text-000000">ผล</span>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.cervical_cancer.last_inspection_result"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                        :disabled="data.cervical_cancer.status == '0' || data.gender == 'ชาย' || data.gender == ''"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกผล</span>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="box" cols="12">
                  <v-row>
                    <v-col cols="auto" class="pr-0" :class="!x_mobile ? 'pt-5 pb-0' : 'pb-0'">
                      <span class="mr-2 font-16 text-000000 w-600">มะเร็งลำไส้(50-70ปี)</span>
                    </v-col>
                    <v-col cols="12" sm="" md="" xl="" lg="" class="d-flex baseline pb-0" :class="x_mobile ? '' : 'pl-0 pb-0'">
                      <span class="mr-2 font-16 text-000000">วันที่ตรวจ</span>
                      <v-menu
                        v-model="day_menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="350px"
                        min-width="auto"
                        bottom
                        left
                        :disabled="status == 'see'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            solo
                            dense
                            append-icon="mdi-calendar-multiselect"
                            :value="displayDate2()"
                            v-bind="attrs"
                            hide-details
                            v-on="on"
                            color="#00A99D"
                            item-color="teal darken-2"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                          >
                            <template slot="append">
                              <v-btn text icon v-on="on">
                                <v-icon color="#00A99D"
                                  >mdi-calendar-multiselect</v-icon
                                >
                              </v-btn>
                            </template>

                            <template slot="label">
                              <span class="font-14">วันที่ตรวจ</span>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="data.colon_cancer.inspection_date"
                          :max="dateNow"
                          no-title
                          scrollable
                          locale="th"
                          @input="day_menu2 = false"
                          color="#00A99D"
                          ref="picker"
                          :disabled="status == 'see'"
                          :active-picker.sync="activePicker"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="#00A99D" @click="clearDaySelect2"
                            >ล้างค่า/clear</v-btn
                          >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="d-flex baseline pb-0" :class="x_mobile ? '' : 'pr-0'">
                      <span class="mr-2 font-16 text-000000">สถานที่ตรวจ</span>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.colon_cancer.inspection_location"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกสถานที่ตรวจ</span>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="d-flex baseline">
                      <span class="mr-2 font-16 text-000000">ผล</span>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.colon_cancer.last_inspection_result"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกผล</span>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" xl="6" lg="6" class="box">
              <v-row>
                <v-col cols="auto" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000 w-600">มะเร็งเต้านม(30-70ปี)</span>
                </v-col>
                <v-col cols="12" sm="" md="" xl="" lg="" :class="x_mobile ? '' : 'pl-0'">
                  <v-row>
                    <v-col cols="auto" class="pb-0">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.breast_cancer.Inspector"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.breast_cancer.Inspector_title = 'ตรวจเอง'"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ตรวจเอง</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="auto" class="pb-0">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.breast_cancer.Inspector"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.breast_cancer.Inspector_title = 'จนท.'"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">จนท.</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col class="d-flex baseline">
                      <span class="mr-2 font-16 text-000000">วันที่ตรวจ</span>
                      <v-menu
                        v-model="day_menu3"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="350px"
                        min-width="auto"
                        bottom
                        left
                        :disabled="status == 'see'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            solo
                            dense
                            append-icon="mdi-calendar-multiselect"
                            :value="displayDate3()"
                            v-bind="attrs"
                            hide-details
                            v-on="on"
                            color="#00A99D"
                            item-color="teal darken-2"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                          >
                            <template slot="append">
                              <v-btn text icon v-on="on">
                                <v-icon color="#00A99D"
                                  >mdi-calendar-multiselect</v-icon
                                >
                              </v-btn>
                            </template>

                            <template slot="label">
                              <span class="font-14">วันที่ตรวจ</span>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="data.breast_cancer.inspection_date"
                          :max="dateNow"
                          no-title
                          scrollable
                          locale="th"
                          @input="day_menu3 = false"
                          color="#00A99D"
                          ref="picker"
                          :disabled="status == 'see'"
                          :active-picker.sync="activePicker"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="#00A99D" @click="clearDaySelect3"
                            >ล้างค่า/clear</v-btn
                          >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="d-flex baseline" :class="x_mobile ? 'pt-0 pb-6' : 'pt-0'">
                      <span class="mr-2 font-16 text-000000">สถานที่ตรวจ</span>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.breast_cancer.inspection_location"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกสถานที่ตรวจ</span>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-0">
                    <v-col class="d-flex baseline" :class="x_mobile ? 'pt-0' : ''">
                      <span class="mr-2 font-16 text-000000">ผล</span>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.breast_cancer.last_inspection_result"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกผล</span>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="box">
              <v-row>
                <v-col cols="auto" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000 w-600"><u>ประเมินพฤติกรรมการทำความสะอาด : สุขภาพช่องปาก</u></span>
                </v-col>
                <v-col cols="12" sm="auto" md="6" xl="auto" lg="auto" :class="x_mobile || tablet ? '' : 'pl-0'">
                  <v-row>
                    <v-col cols="auto" class="pb-0">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.oral_health_screening.decency"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.oral_health_screening.decency_title = 'ไม่เหมาะสม 1B1261'"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ไม่เหมาะสม 1B1261</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="auto" class="pb-0">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.oral_health_screening.decency"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.oral_health_screening.decency_title = 'เหมาะสม 1B1260'"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">เหมาะสม 1B1260</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xl="6" lg="6" class="pb-0">
                  <v-row>
                    <v-col cols="auto" class="pr-0" :class="x_mobile ? 'pb-0' : ''">
                      <span class="mr-2 font-16 text-000000">1.1) แปรงฟัน</span>
                    </v-col>
                    <v-col cols="auto" class="d-flex pl-0" :class="x_mobile ? 'pb-0' : ''">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.oral_health_screening.brushing_teeth.status"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.oral_health_screening.brushing_teeth.answer_title = 'ไม่แปรง',
                                data.oral_health_screening.brushing_teeth.time = '',
                                $refs.form.resetValidation()"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ไม่แปรง</span>
                        </template>
                      </v-checkbox>
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.oral_health_screening.brushing_teeth.status"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.oral_health_screening.brushing_teeth.answer_title = 'แปรง',
                                data.oral_health_screening.brushing_teeth.time = ''"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">แปรง</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="auto" class="d-flex" :class="x_mobile ? '' : ' pl-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.oral_health_screening.brushing_teeth.time"
                        value="วันละครั้ง"
                        color="#00A99D"
                        hide-details="auto"
                        :readonly="status == 'see' || data.oral_health_screening.brushing_teeth.answer_title == 'ไม่แปรง'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">วันละครั้ง</span>
                        </template>
                      </v-checkbox>
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.oral_health_screening.brushing_teeth.time"
                        value="2 ครั้ง/วัน"
                        color="#00A99D"
                        hide-details="auto"
                        :readonly="status == 'see' || data.oral_health_screening.brushing_teeth.answer_title == 'ไม่แปรง'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">2 ครั้ง/วัน</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="auto">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.oral_health_screening.using_toothpaste"
                        color="#00A99D"
                        hide-details="auto"
                        :readonly="status == 'see' || data.oral_health_screening.brushing_teeth.answer_title == 'ไม่แปรง'"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ใช้ยาสีฟัน</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" xl="6" lg="6">
                  <v-row>
                    <v-col cols="auto" class="pr-0" :class="x_mobile ? 'pb-0' : ''">
                      <span class="mr-2 font-16 text-000000">1.2) การทำความสะอาดซอกฟัน</span>
                    </v-col>
                    <v-col cols="auto" class="d-flex" :class="x_mobile ? '' : ' pl-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.oral_health_screening.cleaning_teeth.status"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.oral_health_screening.cleaning_teeth.answer_title = 'ไม่ทำ'"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ไม่ทำ</span>
                        </template>
                      </v-checkbox>
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.oral_health_screening.cleaning_teeth.status"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.oral_health_screening.cleaning_teeth.answer_title = 'ทำ'"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ทำ</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="box">
              <v-row>
                <v-col cols="12" sm="5" md="5" xl="5" lg="5" class="pb-0">
                  <span class="font-16 text-000000 w-600"><u>การคัดกรองสุขภาวะทางตา : สุขภาพตา</u></span>
                </v-col>
                <v-col cols="6" v-if="!x_mobile" class="pb-0">
                  <span class="mr-12 pr-7 font-16 text-000000">ไม่ใช่</span>
                  <span class="font-16 text-000000">ใช่</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="5" md="5" xl="5" lg="5" class="pb-0">
                  <span class="font-16 text-000000">1.นับนิ้วในระยะ 3 เมตรได้ถูกต้อง &lt; 3 ใน 4 ครั้ง</span>
                </v-col>
                <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" class="d-flex pb-0">
                  <v-row>
                    <v-col cols="6" :class="x_mobile ? '' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.eye_health_screening.count_fingers_3m.status"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.eye_health_screening.count_fingers_3m.answer_title = 'ไม่ใช่',
                                data.eye_health_screening.count_fingers_3m.answer_code = '1B1243'"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span v-if="!x_mobile" class="font-16 text-000000">1B1243</span>
                          <span v-else class="font-16 text-000000">ไม่ใช่ 1B1243</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="6" :class="x_mobile ? '' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.eye_health_screening.count_fingers_3m.status"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.eye_health_screening.count_fingers_3m.answer_title = 'ใช่',
                                data.eye_health_screening.count_fingers_3m.answer_code = '1B1245'"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span v-if="!x_mobile" class="font-16 text-000000">1B1245</span>
                          <span v-else class="font-16 text-000000">ใช่ 1B1245</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="5" md="5" xl="5" lg="5" class="pb-0">
                  <span class="font-16 text-000000">2.อ่านหนังสือพิมพ์หน้าหนึ่ง ในระยะ 1 ฟุตไม่ได้</span>
                </v-col>
                <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" class="d-flex pb-0">
                  <v-row>
                    <v-col cols="6" :class="x_mobile ? '' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.eye_health_screening.read_newspaper_1ft.status"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.eye_health_screening.read_newspaper_1ft.answer_title = 'ไม่ใช่',
                                data.eye_health_screening.read_newspaper_1ft.answer_code = '1B1240'"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span v-if="!x_mobile" class="font-16 text-000000">1B1240</span>
                          <span v-else class="font-16 text-000000">ไม่ใช่ 1B1240</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="6" :class="x_mobile ? '' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.eye_health_screening.read_newspaper_1ft.status"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.eye_health_screening.read_newspaper_1ft.answer_title = 'ใช่',
                                data.eye_health_screening.read_newspaper_1ft.answer_code = '1B1242'"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span v-if="!x_mobile" class="font-16 text-000000">1B1242</span>
                          <span v-else class="font-16 text-000000">ใช่ 1B1242</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="5" md="5" xl="5" lg="5" class="pb-0">
                  <span class="font-16 text-000000">3.ปิดตาดูทีละข้าง (ตามัวคล้ายหมอกบัง) ต้อกระจก</span>
                </v-col>
                <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" class="pb-0">
                  <v-row>
                    <v-col cols="6" :class="x_mobile ? '' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.eye_health_screening.blurred_vision.status"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.eye_health_screening.blurred_vision.answer_title = 'ไม่ใช่', 
                                data.eye_health_screening.blurred_vision.answer_code = '1B1250',
                                data.eye_health_screening.blurred_vision.left_eye = null,
                                data.eye_health_screening.blurred_vision.right_eye = null,
                                $refs.form.resetValidation()"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span v-if="!x_mobile" class="font-16 text-000000">1B1250</span>
                          <span v-else class="font-16 text-000000">ไม่ใช่ 1B1250</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="6" :class="x_mobile ? '' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.eye_health_screening.blurred_vision.status"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.eye_health_screening.blurred_vision.answer_title = 'ใช่',
                                data.eye_health_screening.blurred_vision.answer_code = '1B1252'"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span v-if="!x_mobile" class="font-16 text-000000">1B1252</span>
                          <span v-else class="font-16 text-000000">ใช่ 1B1252</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" class="pb-0">
                  <v-row>
                    <v-col cols="6" :class="x_mobile ? '' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.eye_health_screening.blurred_vision.left_eye"
                        color="#00A99D"
                        hide-details="auto"
                        :readonly="status == 'see' || data.eye_health_screening.blurred_vision.status == null || data.eye_health_screening.blurred_vision.status == '0'"
                        :rules="status == 'see' ? [] : data.eye_health_screening.blurred_vision.left_eye == true || data.eye_health_screening.blurred_vision.right_eye == true ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ซ้าย</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="6" :class="x_mobile ? '' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.eye_health_screening.blurred_vision.right_eye"
                        color="#00A99D"
                        hide-details="auto"
                        :readonly="status == 'see' || data.eye_health_screening.blurred_vision.status == null || data.eye_health_screening.blurred_vision.status == '0'"
                        :rules="status == 'see' ? [] : data.eye_health_screening.blurred_vision.left_eye == true || data.eye_health_screening.blurred_vision.right_eye == true ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ขวา</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="5" md="5" xl="5" lg="5" class="pb-0">
                  <span class="font-16 text-000000">4.ปิดตาดูทีละข้าง (มองชัดแค่ตรงกลาง) ต้อหิน</span>
                </v-col>
                <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" class="pb-0">
                  <v-row>
                    <v-col cols="6" :class="x_mobile ? '' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.eye_health_screening.clearly_middle.status"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.eye_health_screening.clearly_middle.answer_title = 'ไม่ใช่',
                                data.eye_health_screening.clearly_middle.answer_code = '1B1253',
                                data.eye_health_screening.clearly_middle.left_eye = null,
                                data.eye_health_screening.clearly_middle.right_eye = null,
                                $refs.form.resetValidation()"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span v-if="!x_mobile" class="font-16 text-000000">1B1253</span>
                          <span v-else class="font-16 text-000000">ไม่ใช่ 1B1253</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="6" :class="x_mobile ? '' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.eye_health_screening.clearly_middle.status"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.eye_health_screening.clearly_middle.answer_title = 'ใช่',
                                data.eye_health_screening.clearly_middle.answer_code = '1B1255'"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span v-if="!x_mobile" class="font-16 text-000000">1B1255</span>
                          <span v-else class="font-16 text-000000">ใช่ 1B1255</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" class="pb-0">
                  <v-row>
                    <v-col cols="6" :class="x_mobile ? '' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.eye_health_screening.clearly_middle.left_eye"
                        color="#00A99D"
                        hide-details="auto"
                        :readonly="status == 'see' || data.eye_health_screening.clearly_middle.status == null || data.eye_health_screening.clearly_middle.status == '0'"
                        :rules="status == 'see' ? [] : data.eye_health_screening.clearly_middle.left_eye == true || data.eye_health_screening.clearly_middle.right_eye == true ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ซ้าย</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="6" :class="x_mobile ? '' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.eye_health_screening.clearly_middle.right_eye"
                        color="#00A99D"
                        hide-details="auto"
                        :readonly="status == 'see' || data.eye_health_screening.clearly_middle.status == null || data.eye_health_screening.clearly_middle.status == '0'"
                        :rules="status == 'see' ? [] : data.eye_health_screening.clearly_middle.left_eye == true || data.eye_health_screening.clearly_middle.right_eye == true ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ขวา</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="5" md="5" xl="5" lg="5" :class="x_mobile ? 'pb-0' : ''">
                  <span class="font-16 text-000000">5.ปิดตาดูทีละข้าง (มองจุดดำกลางภาพ/บิดเบี้ยว) จอตาเสื่อม</span>
                </v-col>
                <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="x_mobile ? 'pb-0' : ''">
                  <v-row>
                    <v-col cols="6" :class="x_mobile ? '' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.eye_health_screening.black_spot_center.status"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.eye_health_screening.black_spot_center.answer_title = 'ไม่ใช่',
                                data.eye_health_screening.black_spot_center.answer_code = '1B1256'
                                data.eye_health_screening.black_spot_center.left_eye = null,
                                data.eye_health_screening.black_spot_center.right_eye = null,
                                $refs.form.resetValidation()"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span v-if="!x_mobile" class="font-16 text-000000">1B1256</span>
                          <span v-else class="font-16 text-000000">ไม่ใช่ 1B1256</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="6" :class="x_mobile ? '' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.eye_health_screening.black_spot_center.status"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.eye_health_screening.black_spot_center.answer_title = 'ใช่',
                                data.eye_health_screening.black_spot_center.answer_code = '1B1258'"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span v-if="!x_mobile" class="font-16 text-000000">1B1258</span>
                          <span v-else class="font-16 text-000000">ใช่ 1B1258</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto">
                  <v-row>
                    <v-col cols="6" :class="x_mobile ? '' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.eye_health_screening.black_spot_center.left_eye"
                        color="#00A99D"
                        hide-details="auto"
                        :readonly="status == 'see' || data.eye_health_screening.black_spot_center.status == null || data.eye_health_screening.black_spot_center.status == '0'"
                        :rules="status == 'see' ? [] : data.eye_health_screening.black_spot_center.left_eye == true || data.eye_health_screening.black_spot_center.right_eye == true ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ซ้าย</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="6" :class="x_mobile ? '' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.eye_health_screening.black_spot_center.right_eye"
                        color="#00A99D"
                        hide-details="auto"
                        :readonly="status == 'see' || data.eye_health_screening.black_spot_center.status == null || data.eye_health_screening.black_spot_center.status == '0'"
                        :rules="status == 'see' ? [] : data.eye_health_screening.black_spot_center.left_eye == true || data.eye_health_screening.black_spot_center.right_eye == true ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ขวา</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xl="6" lg="6" class="box">
              <v-row>
                <v-col cols="auto" class="pr-0" :class="x_mobile ? ' pb-0' : ''">
                  <span class="mr-2 font-16 text-000000 w-600"><u>การคัดกรองโรคข้อเข่าเสื่อม : </u></span>
                </v-col>
                <v-col cols="auto" :class="x_mobile ? '' : 'pl-0'">
                  <v-checkbox
                    class="mt-0 pt-0"
                    dense
                    v-model="data.screening_osteoarthritis.status"
                    value="0"
                    color="#00A99D"
                    hide-details="auto"
                    @click="data.screening_osteoarthritis.answer_title = 'ไม่ปวดเข่า 1B1272'"
                    :readonly="status == 'see'"
                    :rules="status == 'see' ? [] : rules_select"
                  >
                    <template v-slot:label>
                      <span class="font-16 text-000000">ไม่ปวดเข่า 1B1272</span>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="auto">
                  <v-checkbox
                    class="mt-0 pt-0"
                    dense
                    v-model="data.screening_osteoarthritis.status"
                    value="1"
                    color="#00A99D"
                    hide-details="auto"
                    @click="data.screening_osteoarthritis.answer_title = 'ปวดเข่า 1B1270'"
                    :readonly="status == 'see'"
                    :rules="status == 'see' ? [] : rules_select"
                  >
                    <template v-slot:label>
                      <span class="font-16 text-000000">ปวดเข่า 1B1270</span>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" xl="6" lg="6" class="box">
              <v-row>
                <v-col cols="auto" class="pr-0" :class="x_mobile ? ' pb-0' : ''">
                  <span class="mr-2 font-16 text-000000"><u class="w-600">การคัดกรองภาวะกลั้นปัสสาวะ :</u> ปัสสาวะเล็ด/ราดจนทำให้ใช้ชีวิตลำบาก</span>
                </v-col>
                <v-col cols="auto" :class="x_mobile ? '' : 'pl-0'">
                  <v-checkbox
                    class="mt-0 pt-0"
                    dense
                    v-model="data.screening_urinary_incontinence.status"
                    value="0"
                    color="#00A99D"
                    hide-details="auto"
                    @click="data.screening_urinary_incontinence.answer_title = 'ไม่มี'"
                    :readonly="status == 'see'"
                    :rules="status == 'see' ? [] : rules_select"
                  >
                    <template v-slot:label>
                      <span class="font-16 text-000000">ไม่มี</span>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="auto">
                  <v-checkbox
                    class="mt-0 pt-0"
                    dense
                    v-model="data.screening_urinary_incontinence.status"
                    value="1"
                    color="#00A99D"
                    hide-details="auto"
                    @click="data.screening_urinary_incontinence.answer_title = 'มี'"
                    :readonly="status == 'see'"
                    :rules="status == 'see' ? [] : rules_select"
                  >
                    <template v-slot:label>
                      <span class="font-16 text-000000">มี</span>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="box">
              <v-row>
                <v-col cols="auto" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000"><u class="w-600">การคัดกรองภาวะหกล้ม (TUGT) : </u>6 เดือนที่ผ่านมาเคยหกล้ม</span>
                </v-col>
                <v-col cols="auto" class="pb-0" :class="x_mobile ? '' : 'pl-0'">
                  <v-checkbox
                    class="mt-0 pt-0"
                    dense
                    v-model="data.screening_falls.fallen_6months_ago.status"
                    value="0"
                    color="#00A99D"
                    hide-details="auto"
                    @click="data.screening_falls.fallen_6months_ago.answer_title = 'ไม่เคย'"
                    :readonly="status == 'see'"
                    :rules="status == 'see' ? [] : rules_select"
                  >
                    <template v-slot:label>
                      <span class="font-16 text-000000">ไม่เคย</span>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="auto" class="pb-0">
                  <v-checkbox
                    class="mt-0 pt-0"
                    dense
                    v-model="data.screening_falls.fallen_6months_ago.status"
                    value="1"
                    color="#00A99D"
                    hide-details="auto"
                    @click="data.screening_falls.fallen_6months_ago.answer_title = 'เคย'"
                    :readonly="status == 'see'"
                    :rules="status == 'see' ? [] : rules_select"
                  >
                    <template v-slot:label>
                      <span class="font-16 text-000000">เคย</span>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-row class="baseline">
                    <v-col cols="auto" class="pr-0 pb-0">
                      <span class="mr-2 font-16 text-000000">จับเวลาได้</span>
                    </v-col>
                    <v-col xl="auto" lg="auto" class="pl-0 pb-0 d-flex" :class="x_mobile || tablet ? '' : 'pr-0'">
                      <v-row>
                        <v-col cols="auto" class="d-flex baseline" :class="x_mobile ? '' : 'pr-0'">
                          <v-autocomplete
                            :items="minute"
                            color="#00A99D"
                            item-color="teal darken-2"
                            class="px-0"
                            dense
                            solo
                            hide-details="auto"
                            v-model="data.screening_falls.count_time.minute"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                          >
                            <template slot="label">
                              <span class="font-14">นาที</span>
                            </template>
                          </v-autocomplete>
                          <span class="pl-2 font-16 text-000000">นาที</span>
                        </v-col>
                        <v-col cols="auto" class="d-flex baseline">
                          <v-autocomplete
                            :items="second"
                            color="#00A99D"
                            item-color="teal darken-2"
                            class="px-0"
                            dense
                            solo
                            hide-details="auto"
                            v-model="data.screening_falls.count_time.second"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                          >
                            <template slot="label">
                              <span class="font-14">วินาที</span>
                            </template>
                          </v-autocomplete>
                          <span class="pl-2 font-16 text-000000">วินาที</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="auto" class="pb-0 d-flex">
                      <v-row class="baseline">
                        <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pr-0' : 'pb-0'">
                          <v-checkbox
                            class="mt-0 pt-0"
                            dense
                            v-model="data.screening_falls.walking.status"
                            value="0"
                            color="#00A99D"
                            hide-details="auto"
                            @click="data.screening_falls.walking.answer_title = 'เดินไม่ได้'"
                            :readonly="status == 'see'"
                            :rules="status == 'see' ? [] : rules_select"
                          >
                            <template v-slot:label>
                              <span class="font-16 text-000000">เดินไม่ได้</span>
                            </template>
                          </v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? '' : 'pb-0'">
                          <v-checkbox
                            class="mt-0 pt-0"
                            dense
                            v-model="data.screening_falls.walking.status"
                            value="1"
                            color="#00A99D"
                            hide-details="auto"
                            @click="data.screening_falls.walking.answer_title = 'ปกติ 1B1200'"
                            :readonly="status == 'see'"
                            :rules="status == 'see' ? [] : rules_select"
                          >
                            <template v-slot:label>
                              <span class="font-16 text-000000">ปกติ 1B1200</span>
                            </template>
                          </v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto">
                          <v-checkbox
                            class="mt-0 pt-0"
                            dense
                            v-model="data.screening_falls.walking.status"
                            value="2"
                            color="#00A99D"
                            hide-details="auto"
                            @click="data.screening_falls.walking.answer_title = 'มีความเสี่ยงต่อภาวะหกล้ม TUGT >= 12 1B1202'"
                            :readonly="status == 'see'"
                            :rules="status == 'see' ? [] : rules_select"
                          >
                            <template v-slot:label>
                              <span class="font-16 text-000000">มีความเสี่ยงต่อภาวะหกล้ม TUGT &#8805; 12 1B1202</span>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <span class="font-16 text-000000">(ให้ผู้สูงอายุเดินจากเก้าอี้ที่นั่ง วัดระยะ 3 เมตร เดินเป็นเส้นตรง (ใช้อุปกรณ์ช่วยเดินที่ใช้ประจำได้) ไป-กลับ)</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="box">
              <v-row>
                <v-col cols="auto" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000 w-600"><u>การประเมินความสามารถในการทำกิจกรรมประจำวัน : ADL</u></span>
                </v-col>
              </v-row>
              <!-- 1 -->
              <v-row>
                <v-col cols="12" md="3" xl="3" lg="3" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000">1.กินอาหาร เมื่อเตรียมไว้ตรงหน้า : </span>
                </v-col>
                <v-col class="pr-0 d-flex pb-0">
                  <v-row>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pr-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.food_in_front.score"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.food_in_front.answer_title = 'ทำไม่ได้ (0)', calScore('food_in_front')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ทำไม่ได้ (0)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'px-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.food_in_front.score"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.food_in_front.answer_title = 'มีคนช่วย (1)', calScore('food_in_front')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">มีคนช่วย (1)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pl-0' : ''">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.daily_activities.food_in_front.score"
                        value="2"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.food_in_front.answer_title = 'ทำได้เอง (2)', calScore('food_in_front')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ทำได้เอง (2)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 2 -->
              <v-row>
                <v-col cols="12" md="3" xl="3" lg="3" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000">2.ล้างหน้า หวีผม แปรงฟัน โกนหนวด : </span>
                </v-col>
                <v-col class="pr-0 d-flex pb-0">
                  <v-row>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pr-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.clean_face.score"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.clean_face.answer_title = 'ทำไม่ได้ (0)', calScore('clean_face')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ทำไม่ได้ (0)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'px-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.clean_face.score"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.clean_face.answer_title = 'มีคนช่วย (1)', calScore('clean_face')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">มีคนช่วย (1)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pl-0' : ''">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.daily_activities.clean_face.score"
                        value="2"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.clean_face.answer_title = 'ทำได้เอง (2)', calScore('clean_face')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ทำได้เอง (2)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 3 -->
              <v-row>
                <v-col cols="12" md="3" xl="3" lg="3" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000">3.ลุกนั่งจากที่นอน/จากเตียงไปเก้าอี้ : </span>
                </v-col>
                <v-col class="pr-0 d-flex pb-0">
                  <v-row>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pr-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.wake_from_bed.score"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.wake_from_bed.answer_title = 'ทำไม่ได้ (0)', calScore('wake_from_bed')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ทำไม่ได้ (0)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'px-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.wake_from_bed.score"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.wake_from_bed.answer_title = 'ต้องมีคนช่วยตลอด (1)', calScore('wake_from_bed')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ต้องมีคนช่วยตลอด (1)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'px-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.wake_from_bed.score"
                        value="2"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.wake_from_bed.answer_title = 'ต้องมีคนช่วยบ้าง (2)', calScore('wake_from_bed')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ต้องมีคนช่วยบ้าง (2)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pl-0' : ''">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.daily_activities.wake_from_bed.score"
                        value="3"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.wake_from_bed.answer_title = 'เดินได้เอง (3)', calScore('wake_from_bed')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">เดินได้เอง (3)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 4 -->
              <v-row>
                <v-col cols="12" md="3" xl="3" lg="3" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000">4.การใช้ห้องน้ำ : </span>
                </v-col>
                <v-col class="pr-0 d-flex pb-0">
                  <v-row>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pr-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.using_bathroom.score"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.using_bathroom.answer_title = 'ช่วยตัวเองไม่ได้ (0)', calScore('using_bathroom')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ช่วยตัวเองไม่ได้ (0)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'px-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.using_bathroom.score"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.using_bathroom.answer_title = 'ทำได้บ้าง (1)', calScore('using_bathroom')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ทำได้บ้าง (1)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pl-0' : ''">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.daily_activities.using_bathroom.score"
                        value="2"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.using_bathroom.answer_title = 'ทำได้ดี (2)', calScore('using_bathroom')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ทำได้ดี (2)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 5 -->
              <v-row>
                <v-col cols="12" md="3" xl="3" lg="3" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000">5.การเคลื่อนที่ภายในห้อง/บ้าน : </span>
                </v-col>
                <v-col class="pr-0 d-flex pb-0">
                  <v-row>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pr-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.movement.score"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.movement.answer_title = 'ไม่ได้ (0)', calScore('movement')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ไม่ได้ (0)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'px-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.movement.score"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.movement.answer_title = 'ต้องใช้รถเข็น (1)', calScore('movement')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ต้องใช้รถเข็น (1)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'px-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.movement.score"
                        value="2"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.movement.answer_title = 'ต้องมีคนพยุง (2)', calScore('movement')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ต้องมีคนพยุง (2)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pl-0' : ''">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.daily_activities.movement.score"
                        value="3"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.movement.answer_title = 'เดินเอง (3)', calScore('movement')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">เดินเอง (3)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 6 -->
              <v-row>
                <v-col cols="12" md="3" xl="3" lg="3" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000">6.การสวมใส่เสื้อผ้า : </span>
                </v-col>
                <v-col class="pr-0 d-flex pb-0">
                  <v-row>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pr-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.wearing_clothes.score"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.wearing_clothes.answer_title = 'ต้องมีคนใส่ให้ (0)', calScore('wearing_clothes')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ต้องมีคนใส่ให้ (0)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'px-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.wearing_clothes.score"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.wearing_clothes.answer_title = 'ช่วยตัวเองครึ่งคนอื่นช่วยครึ่ง (1)', calScore('wearing_clothes')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ช่วยตัวเองครึ่งคนอื่นช่วยครึ่ง (1)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pl-0' : ''">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.daily_activities.wearing_clothes.score"
                        value="2"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.wearing_clothes.answer_title = 'ทำเอง (2)', calScore('wearing_clothes')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ทำเอง (2)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 7 -->
              <v-row>
                <v-col cols="12" md="3" xl="3" lg="3" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000">7.การขึ้นลงบันได 1 ขั้น : </span>
                </v-col>
                <v-col class="pr-0 d-flex pb-0">
                  <v-row>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pr-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.stairs_1step.score"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.stairs_1step.answer_title = 'ทำไม่ได้ (0)', calScore('stairs_1step')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ทำไม่ได้ (0)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'px-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.stairs_1step.score"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.stairs_1step.answer_title = 'ต้องมีคนช่วย (1)', calScore('stairs_1step')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ต้องมีคนช่วย (1)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pl-0' : ''">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.daily_activities.stairs_1step.score"
                        value="2"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.stairs_1step.answer_title = 'ขึ้นลงได้เอง (2)', calScore('stairs_1step')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ขึ้นลงได้เอง (2)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 8 -->
              <v-row>
                <v-col cols="12" md="3" xl="3" lg="3" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000">8.การอาบน้ำ : </span>
                </v-col>
                <v-col class="pr-0 d-flex pb-0">
                  <v-row>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pr-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.shower.score"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.shower.answer_title = 'ต้องมีคนช่วย (0)', calScore('shower')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">ต้องมีคนช่วย (0)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pl-0' : ''">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.shower.score"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.shower.answer_title = 'อาบได้เอง (1)', calScore('shower')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">อาบได้เอง (1)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 9 -->
              <v-row>
                <v-col cols="12" md="3" xl="3" lg="3" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000">9.การกลั้นการถ่ายอุจจาระ : </span>
                </v-col>
                <v-col class="pr-0 d-flex pb-0">
                  <v-row>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pr-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.suppress_defecation.score"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.suppress_defecation.answer_title = 'กลั้นไม่ได้ (0)', calScore('suppress_defecation')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">กลั้นไม่ได้ (0)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'px-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.suppress_defecation.score"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.suppress_defecation.answer_title = 'กลั้นได้บางครั้ง (1)', calScore('suppress_defecation')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">กลั้นได้บางครั้ง (1)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pl-0' : ''">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.daily_activities.suppress_defecation.score"
                        value="2"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.suppress_defecation.answer_title = 'กลั้นได้ปกติ (2)', calScore('suppress_defecation')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">กลั้นได้ปกติ (2)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 10 -->
              <v-row>
                <v-col cols="12" md="3" xl="3" lg="3" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000">10.การกลั้นปัสสาวะ : </span>
                </v-col>
                <v-col class="pr-0 d-flex pb-0">
                  <v-row>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pr-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.holding_urine.score"
                        value="0"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.holding_urine.answer_title = 'กลั้นไม่ได้ (0)', calScore('holding_urine')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">กลั้นไม่ได้ (0)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'px-0' : 'pb-0'">
                      <v-checkbox
                        class="mt-0 pt-0 pr-3"
                        dense
                        v-model="data.daily_activities.holding_urine.score"
                        value="1"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.holding_urine.answer_title = 'กลั้นได้บางครั้ง (1)', calScore('holding_urine')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">กลั้นได้บางครั้ง (1)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pl-0' : ''">
                      <v-checkbox
                        class="mt-0 pt-0"
                        dense
                        v-model="data.daily_activities.holding_urine.score"
                        value="2"
                        color="#00A99D"
                        hide-details="auto"
                        @click="data.daily_activities.holding_urine.answer_title = 'กลั้นได้ปกติ (2)', calScore('holding_urine')"
                        :readonly="status == 'see'"
                        :rules="status == 'see' ? [] : rules_select"
                      >
                        <template v-slot:label>
                          <span class="font-16 text-000000">กลั้นได้ปกติ (2)</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- total -->
              <v-row>
                <v-col cols="auto" md="3" xl="3" lg="3" class="d-flex baseline">
                  <span class="mr-2 font-16 text-000000">รวม</span>
                  <v-text-field
                    dense
                    solo
                    hide-details="auto"
                    v-model="data.daily_activities.total_score"
                    readonly
                  >
                    <template slot="label">
                      <span class="font-14">รวม</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col class="pr-0 baseline" :class="x_mobile ? ' pb-0' : tablet ? 'pt-5' : 'pt-5 d-flex'">
                  <v-checkbox
                    class="mt-0 pt-0 pr-3"
                    dense
                    :class="x_mobile || tablet ? 'pb-3' : ''"
                    v-model="data.daily_activities.group_type.status"
                    value="0"
                    color="#00A99D"
                    hide-details="auto"
                    @click="data.daily_activities.group_type.answer_title = 'กลุ่ม 1 ได้ >= 12 คะแนน 1B1280'"
                    readonly
                  >
                    <template v-slot:label>
                      <span class="font-16 text-000000">กลุ่ม 1 ได้ &#8805; 12 คะแนน 1B1280</span>
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="mt-0 pt-0 pr-3"
                    dense
                    :class="x_mobile || tablet ? 'pb-3' : ''"
                    v-model="data.daily_activities.group_type.status"
                    value="1"
                    color="#00A99D"
                    hide-details="auto"
                    @click="data.daily_activities.group_type.answer_title = 'กลุ่ม 2 ได้ 5-11 คะแนน 1B1281'"
                    readonly
                  >
                    <template v-slot:label>
                      <span class="font-16 text-000000">กลุ่ม 2 ได้ 5-11 คะแนน 1B1281</span>
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="mt-0 pt-0"
                    dense
                    :class="x_mobile ? 'pb-3' : ''"
                    v-model="data.daily_activities.group_type.status"
                    value="2"
                    color="#00A99D"
                    hide-details="auto"
                    @click="data.daily_activities.group_type.answer_title = 'กลุ่ม 3 ได้ <=4 คะแนน 1B1282'"
                    readonly
                  >
                    <template v-slot:label>
                      <span class="font-16 text-000000">กลุ่ม 3 ได้ &#8804; 4 คะแนน 1B1282</span>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="box">
              <v-row>
                <v-col cols="auto" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000 w-600"><u>การคัดกรองสมรรถภาพสมอง ด้วย Mini-Cog</u></span>
                </v-col>
                <v-col cols="12" xl="auto" lg="auto" class="pr-0 pb-0">
                  <span class="mr-2 font-16 text-000000">เกณฑ์การประเมิน คะแนนเต็ม 5 คะแนน</span>
                </v-col>
                <v-col cols="12" xl="auto" lg="auto" class="pr-0 pb-0">
                  <v-checkbox
                    class="mt-0 pt-0 pr-3"
                    dense
                    v-model="data.brain_performance.status"
                    value="0"
                    color="#00A99D"
                    hide-details="auto"
                    @click="data.brain_performance.answer_title = '<= 3 คะแนน มีภาวะบกพร่องทางการรู้คิด ส่งต่อ คลินิกผู้สูงอายุ'"
                    readonly
                  >
                    <template v-slot:label>
                      <span class="font-16 text-000000">&#8804; 3 คะแนน มีภาวะบกพร่องทางการรู้คิด ส่งต่อ คลินิกผู้สูงอายุ</span>
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="mt-0 pt-0"
                    dense
                    v-model="data.brain_performance.status"
                    value="1"
                    color="#00A99D"
                    hide-details="auto"
                    @click="data.brain_performance.answer_title = '4 คะแนนขึ้นไป ภาวะรู้สึกปกติ'"
                    readonly
                  >
                    <template v-slot:label>
                      <span class="font-16 text-000000">4 คะแนนขึ้นไป ภาวะรู้สึกปกติ</span>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row style="align-items: center !important;">
                <v-col cols="12" xl="3" lg="3" :class="x_mobile || tablet ? 'pb-0' : 'pb-10'" style="text-align: -webkit-center !important;">
                  <v-card :disabled="status == 'see'" outlined :style="!isWrite ? 'border: 1px solid #333333;': 'border: 2px solid #00A99D;'" :id="x_mobile || tablet ? 'bigSignature' : 'bigSignature2'">
                    <v-card-title>
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-tooltip v-if="data.brain_performance.clock_img !== '' && status == 'register' && edit == false" bottom>
                        <!-- <v-tooltip v-if="data.brain_performance.clock_img !== ''" bottom> -->
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" class="mr-2" fab small text depressed :disabled="!isWrite || (data.brain_performance.clock_img !== '' && edit == false)" @click="edit = true">
                              <v-icon size="30" color="#00A99D">mdi-pen</v-icon>
                            </v-btn>
                          </template>
                          <span>แก้ไข</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" class="mr-2" fab small text depressed :disabled="!isWrite || (data.brain_performance.clock_img !== '' && edit == false)" @click="clearBack()">
                              <v-icon size="30" :color="!isWrite || (data.brain_performance.clock_img !== '' && edit == false) ? '#333333':'#00A99D'">mdi-replay</v-icon>
                            </v-btn>
                          </template>
                          <span>ย้อนกลับ</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small text depressed :disabled="!isWrite || (data.brain_performance.clock_img !== '' && edit == false)" @click="clearSign()">
                              <v-icon size="30" :color="!isWrite || (data.brain_performance.clock_img !== '' && edit == false) ? '#333333':'#EB5757'">mdi-cancel</v-icon>
                            </v-btn>
                          </template>
                          <span>ล้างค่า</span>
                        </v-tooltip>
                      </v-row>
                    </v-card-title>

                    <v-card-text v-if="data.brain_performance.clock_img !== '' && edit == false">
                      <v-img :src="data.brain_performance.clock_img"/>
                    </v-card-text>
                    <v-card-text v-else :class="x_mobile ? 'pa-0' : ''">
                      <VueSignaturePad
                        id="signature"
                        ref="signaturePad"
                        :options="{
                          onBegin: () => {
                            $refs.signaturePad.resizeCanvas();
                          },
                          onEnd,
                        }"
                      />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col :class="x_mobile || tablet ? '' : 'pr-0'">
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <span class="mr-2 font-16 text-000000 w-600">แนวทางปฏิบัติ</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <span class="mr-2 font-16 text-000000">1. จนท. บอก 3 คำ ให้กับผู้ทดสอบจำและพูดตาม “ <u>หลานสาว, สวรรค์, ภูเขา</u> ” เดี่ยวจะกลับมาถามซ้ำ</span>
                    </v-col>
                    <v-col cols="12" class="d-flex pb-0">
                      <v-row class="baseline">
                        <v-col cols="auto" :class="x_mobile ? 'pb-0' : 'pr-0'">
                          <span class="mr-2 font-16 text-000000">2. ให้ผู้ทดสอบวาดรูปนาฬิกาโดยใส่ “ <u>ตัวเลขและเข็มนาฬิกาที่เวลา 11.10 น.</u> ” รวม</span>
                        </v-col>
                        <v-col cols="3" sm="1" md="1" xl="1" lg="1" :class="x_mobile ? 'pr-0' : 'px-0'">
                          <v-text-field
                            dense
                            solo
                            hide-details="auto"
                            v-model="data.brain_performance.score_drawing_clock"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                            @input="calScore2('score_drawing_clock')"
                          >
                            <template slot="label">
                              <span class="font-14">คะแนน</span>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col class="pl-0">
                          <span class="ml-2 font-16 text-000000">คะแนน</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <span class="mr-2 font-16 text-000000">(ทำได้ทั้งสอง = 2 คะแนน / ทำอย่างใดอย่างหนึ่ง = 0 คะแนน)</span>
                    </v-col>
                    <v-col cols="12" class="d-flex">
                      <v-row class="baseline">
                        <v-col cols="auto" :class="x_mobile ? 'pb-0' : 'pr-0'">
                          <span class="mr-2 font-16 text-000000">3. จนท. ถาม ผู้ทดสอบ 3 คำ ที่ให้จำ มีอะไรบ้าง (คำละ 1 คะแนน) รวม</span>
                        </v-col>
                        <v-col cols="3" sm="1" md="1" xl="1" lg="1" :class="x_mobile ? 'pr-0' : 'px-0'">
                          <v-text-field
                            dense
                            solo
                            hide-details="auto"
                            v-model="data.brain_performance.score_3words"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                            @input="calScore2('score_3words')"
                          >
                            <template slot="label">
                              <span class="font-14">คะแนน</span>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col class="pl-0">
                          <span class="ml-2 font-16 text-000000">คะแนน</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-text class="py-3 pb-8 px-10" v-else>
        <v-row class="pb-3 baseline">
          <span class="mr-2 font-16 text-000000 w-600">ชุมชน : </span>
          <span class="mr-2 font-16 text-000000">{{ data.community_name || '-' }}</span>
        </v-row>
        <v-row class="pb-3 baseline">
          <span class="mr-2 font-16 text-000000 w-600">บ้านเลขที่ : </span>
          <span class="mr-2 font-16 text-000000">{{ data.house_no || '-' }}</span>
        </v-row>
        <v-row class="pb-3 mt-0">
          <v-col cols="12" sm="6" md="6" xl="5" lg="5" class="d-flex baseline" :class="x_mobile ? 'px-0' : 'pl-0'">
            <span class="mr-2 font-16 text-000000 w-600">เลขบัตรประชาชน : </span>
            <span class="mr-2 font-16 text-000000">{{ cardnum || '-' }}</span>
          </v-col>
          <v-col cols="12" sm="6" md="6" xl="5" lg="5" class="d-flex baseline" :class="x_mobile ? 'px-0 pt-0' : tablet ? 'px-0' : 'pl-0'">
            <span class="mr-2 font-16 text-000000 w-600">ชื่อ-สกุล : </span>
            <span class="mr-2 font-16 text-000000">{{ data.fullname || '-' }}</span>
          </v-col>
          <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex baseline" :class="x_mobile ? 'px-0 pt-0' : tablet ? 'pl-0 pt-0' : 'px-0'">
            <span class="mr-2 font-16 text-000000 w-600">เพศ : </span>
            <span class="mr-2 font-16 text-000000">{{ data.gender || '-' }}</span>
          </v-col>
          <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex baseline" :class="x_mobile || tablet ? 'px-0 pt-0' : 'pl-0 pt-0'">
            <span class="mr-2 font-16 text-000000 w-600">ว.ด.ป. : </span>
            <span class="mr-2 font-16 text-000000">{{ data.birth_date == '' ? '-' :formatDate(data.birth_date) }}</span>
          </v-col>
          <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex baseline" :class="x_mobile ? 'px-0 pt-0' : tablet ? 'pr-0 pt-0' : 'pt-0 pl-0'">
            <span class="mr-2 font-16 text-000000 w-600">อายุ : </span>
            <span class="mr-2 font-16 text-000000">{{ data.age || '-' }} ปี</span>
          </v-col>
          <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex baseline" :class="x_mobile ? 'px-0 pt-0' : tablet ? 'pl-0 pt-0' : 'pt-0 pl-0'">
            <span class="mr-2 font-16 text-000000 w-600">นน : </span>
            <span class="mr-2 font-16 text-000000">{{ data.weight || '-' }} กก.</span>
          </v-col>
          <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex baseline" :class="x_mobile || tablet ? 'px-0 pt-0' : 'pt-0 pl-0'">
            <span class="mr-2 font-16 text-000000 w-600">สส : </span>
            <span class="mr-2 font-16 text-000000">{{ data.height || '-' }} ซม.</span>
          </v-col>
          <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex" :class="x_mobile ? 'px-0 pt-0' : tablet ? 'pr-0 pt-0' : 'pt-0 pl-0'">
            <v-row class="baseline">
              <v-col cols="auto" class="pr-0 mr-2">
                <span class="font-16 text-000000 w-600">รอบเอว : </span>
              </v-col>
              <v-col class="pl-0">
                <span class="mr-2 font-16 text-000000">{{ data.around_waist || '-' }} นิ้ว.</span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex baseline" :class="x_mobile ? 'px-0 pt-0' : tablet ? 'pl-0 pt-0' : 'pt-0 px-0'">
            <span class="mr-2 font-16 text-000000 w-600">Tel : </span>
            <span class="mr-2 font-16 text-000000">{{ data.mobile || '-' }}</span>
          </v-col>
        </v-row>
        <v-row class="pb-3 mt-0">
          <v-col cols="12" xl="5" lg="5" :class="x_mobile || tablet ? 'px-0 pt-0' : 'pl-0 pt-0'">
            <span class="font-16 text-000000 pr-0 mr-2"><span class="w-600">โรคประจำตัว</span> DM/HT/DLP/อื่นๆ ระบุ : {{ data.personal_diseases || '-' }}</span>
          </v-col>
          <v-col cols="12" xl="3" lg="3" :class="x_mobile || tablet ? 'px-0 pt-0' : 'pl-0 pt-0'">
            <span class="font-16 text-000000 pr-0 mr-2"><span class="w-600">สถานที่รักษา : </span>{{ data.treatment_location || '-' }}</span>
          </v-col>
          <v-col cols="12" xl="4" lg="4" class="d-flex" align-self="center" :class="x_mobile || tablet ? 'px-0 pt-0' : 'pl-0 pt-0'">
            <span class="font-16 text-000000"><span class="w-600">ความเสี่ยง : </span> รอยพับคอรักแร้ดำ /LDL&lt;50mg&lt; IFG</span>
          </v-col>
        </v-row>
        <v-row class="pb-3 mt-0">
          <v-col cols="12" xl="6" lg="6" :class="x_mobile || tablet ? 'px-0 pt-0' : 'pl-0 pt-0'">
            <span class="font-16 text-000000 pr-0 mr-2"><span class="w-600">ญาติ</span> ผู้ดูแล(กรณีผส./ผู้มีภาวะพึ่งพิง) : {{ data.caretaker_name || '-' }}</span>
          </v-col>
          <v-col cols="12" xl="6" lg="6" class="d-flex" align-self="center" :class="x_mobile || tablet ? 'px-0 pt-0' : 'pl-0 pt-0'">
            <span class="font-16 text-000000"><span class="w-600">ประวัติครอบครัว : </span>  DM /HT /CVD</span>
          </v-col>
        </v-row>
        <v-row class="pb-3 mt-0">
          <v-col class="box">
            <v-row>
              <v-col>
                <span class="font-16 text-000000 w-600"><u>คัดกรองความเสี่ยงโรคเบาหวานและโรคความดันโลหิตสูง อายุ 35 ปีขึ้นไป</u></span>
              </v-col>
            </v-row>
            <v-row class="mt-0">
              <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex">
                <v-row class="baseline">
                  <v-col cols="auto" class="pr-0">
                    <span class="mr-2 font-16 text-000000"><span class="w-600"><u>BP </u></span> ครั้งที่ 1 : </span>
                  </v-col>
                  <v-col :class="x_mobile ? 'pl-0' : 'px-0'">
                    <span class="mr-2 font-16 text-000000">{{ data.screening_risk_over35.BP1 || '-' }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex" :class="x_mobile ? 'pt-0' : ''">
                <v-row class="baseline">
                  <v-col cols="auto" class="pr-0">
                    <span class="mr-2 font-16 text-000000">ครั้งที่ 2 : </span>
                  </v-col>
                  <v-col :class="x_mobile ? 'pl-0' : 'px-0'">
                    <span class="mr-2 font-16 text-000000">{{ data.screening_risk_over35.BP2 || '-' }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="4" md="4" xl="2" lg="2" class="d-flex" :class="x_mobile ? 'pt-0' : ''">
                <v-row class="baseline">
                  <v-col cols="auto" class="pr-0">
                    <span class="mr-2 font-16 text-000000">/ <span class="w-600"><u>CVD Risk : </u></span></span>
                  </v-col>
                  <v-col class="px-0">
                    <span class="mr-2 font-16 text-000000">{{ data.screening_risk_over35.CVD_Risk || '-' }} %</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="d-flex" :class="x_mobile || tablet ? 'pt-0' : ''">
                <v-row class="baseline">
                  <v-col cols="auto" class="pr-0">
                    <span class="mr-2 font-16 text-000000">(คำนวณผ่านเว็บไซต์) / <span class="w-600"><u>DTX : </u></span></span>
                  </v-col>
                  <v-col class="px-0">
                    <span class="mr-2 font-16 text-000000">{{ data.screening_risk_over35.DTX || '-' }} mg%</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="auto" sm="6" md="6" xl="2" lg="2" :class="x_mobile || tablet ? 'pt-0' : ''">
                <span class="font-16 text-000000">({{ data.screening_risk_over35.normality.answer_title || '-' }})</span>
              </v-col>
            </v-row>
            <v-row class="mt-0">
              <v-col cols="auto">
                <v-row>
                  <v-col cols="auto pr-0">
                    <span class="mr-2 font-16 text-000000"><u class="w-600">สูบบุหรี่ : </u>{{ data.screening_risk_over35.smoking.answer_title || '-' }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="auto">
                <v-row>
                  <v-col cols="auto pr-0">
                    <span class="mr-2 font-16 text-000000"><u class="w-600">แอลกอฮอล์ : </u>{{ data.screening_risk_over35.alcohol.answer_title || '-' }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="box mt-0">
          <v-col>
            <v-row>
              <v-col cols="auto" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000 w-600"><u>การคัดกรองโรคซึมเศร้า 2Q : </u></span>
              </v-col>
              <v-col cols="auto" :class="x_mobile || tablet ? '' : 'px-0'">
                <v-row>
                  <v-col cols="12" sm="auto" md="6" xl="auto" lg="auto" class="pb-0">
                    <span class="mr-2 font-16 text-000000">{{ data.information_depression.answer_title || '-' }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="auto" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000">1.ใน 2 สัปดาห์ รู้สึกหดหู่ เศร้า หรือท้อแท้ สิ้นหวัง : </span>
              </v-col>
              <v-col cols="auto" class="pb-0" :class="x_mobile ? '' : 'pl-0'">
                <span class="mr-2 font-16 text-000000">{{ data.information_depression.subanswer_title_1.answer_title || '-' }}</span>
              </v-col>
            </v-row>
            <v-row :class="x_mobile ? '' : 'mt-0'">
              <v-col cols="auto" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000">2.ใน 2 สัปดาห์ รู้สึก เบื่อ ทำอะไรก็ไม่เพลิน : </span>
              </v-col>
              <v-col cols="auto" :class="x_mobile ? '' : 'pl-0'">
                <span class="mr-2 font-16 text-000000">{{ data.information_depression.subanswer_title_2.answer_title || '-' }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xl="6" lg="6">
            <v-row>
              <v-col class="box" cols="12">
                <v-row>
                  <v-col cols="auto" class="pr-0 pb-0">
                    <span class="mr-2 font-16 text-000000 w-600">มะเร็งปากมดลูก(30-60ปี) : </span>
                  </v-col>
                  <v-col cols="12" sm="" md="" xl="" lg="" :class="x_mobile ? '' : 'pl-0'">
                    <v-row>
                      <v-col cols="auto" class="pb-0">
                        <span class="mr-2 font-16 text-000000">{{ data.cervical_cancer.answer_title || '-' }}ตรวจ</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="d-flex baseline pb-0" :class="x_mobile ? '' : 'pr-0'">
                    <span class="mr-2 font-16 text-000000">ที่ตรวจ : </span>
                    <span class="mr-2 font-16 text-000000">{{ data.cervical_cancer.inspection_location || '-' }}</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="d-flex baseline">
                    <span class="mr-2 font-16 text-000000">ผล : </span>
                    <span class="mr-2 font-16 text-000000">{{ data.cervical_cancer.last_inspection_result || '-' }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="box" cols="12">
                <v-row>
                  <v-col cols="auto" class="pr-0" :class="!x_mobile ? 'pb-0' : 'pb-0'">
                    <span class="mr-2 font-16 text-000000 w-600">มะเร็งลำไส้(50-70ปี)</span>
                  </v-col>
                  <v-col cols="12" sm="" md="" xl="" lg="" class="d-flex baseline pb-0" :class="x_mobile ? '' : 'pl-0 pb-0'">
                    <span class="mr-2 font-16 text-000000">วันที่ตรวจ : </span>
                    <span class="mr-2 font-16 text-000000">{{ data.colon_cancer.inspection_date == '' ? '-' : formatDate(data.colon_cancer.inspection_date) || '-' }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="d-flex baseline pb-0" :class="x_mobile ? '' : 'pr-0'">
                    <span class="mr-2 font-16 text-000000">สถานที่ตรวจ : </span>
                    <span class="mr-2 font-16 text-000000">{{ data.colon_cancer.inspection_location || '-' }}</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="d-flex baseline">
                    <span class="mr-2 font-16 text-000000">ผล : </span>
                    <span class="mr-2 font-16 text-000000">{{ data.colon_cancer.last_inspection_result || '-' }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" xl="6" lg="6" class="box">
            <v-row>
              <v-col cols="auto" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000 w-600">มะเร็งเต้านม(30-70ปี)</span>
              </v-col>
              <v-col cols="12" sm="" md="" xl="" lg="" :class="x_mobile ? '' : 'pl-0'">
                <v-row>
                  <v-col cols="auto" class="pb-0">
                    <span class="mr-2 font-16 text-000000">ผู้ตรวจ : {{ data.breast_cancer.Inspector_title || '-' }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col class="d-flex baseline">
                    <span class="mr-2 font-16 text-000000">วันที่ตรวจ : </span>
                    <span class="mr-2 font-16 text-000000">{{ data.breast_cancer.inspection_date == '' ? '-' : formatDate(data.breast_cancer.inspection_date) }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="d-flex baseline" :class="x_mobile ? 'pt-0 pb-6' : 'pt-0'">
                    <span class="mr-2 font-16 text-000000">สถานที่ตรวจ : </span>
                    <span class="mr-2 font-16 text-000000">{{ data.breast_cancer.inspection_location || '-' }}</span>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col class="d-flex baseline" :class="x_mobile ? 'pt-0' : ''">
                    <span class="mr-2 font-16 text-000000">ผล : </span>
                    <span class="mr-2 font-16 text-000000">{{ data.breast_cancer.last_inspection_result || '-' }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="box">
            <v-row>
              <v-col cols="auto" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000 w-600"><u>ประเมินพฤติกรรมการทำความสะอาด : สุขภาพช่องปาก : </u></span>
              </v-col>
              <v-col cols="12" sm="auto" md="6" xl="auto" lg="auto" :class="x_mobile || tablet ? '' : 'pl-0'">
                <v-row>
                  <v-col cols="auto" class="pb-0">
                    <span class="mr-2 font-16 text-000000">{{ data.oral_health_screening.decency_title || '-' }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xl="6" lg="6" class="pb-0">
                <v-row>
                  <v-col cols="auto" class="pr-0" :class="x_mobile ? 'pb-0' : ''">
                    <span class="mr-2 font-16 text-000000">1.1) แปรงฟัน : </span>
                  </v-col>
                  <v-col cols="auto" class="d-flex px-0" :class="x_mobile ? 'pb-0' : ''">
                    <span class="font-16 text-000000">{{ data.oral_health_screening.brushing_teeth.answer_title || '-' }}</span>
                  </v-col>
                  <span class="pt-3 font-16 text-000000">/</span>
                  <v-col cols="auto" class="d-flex px-0">
                    <span v-if="data.oral_health_screening.brushing_teeth.answer_title != 'ไม่แปรง'" class="font-16 text-000000">{{ data.oral_health_screening.brushing_teeth.time || '-' }}</span>
                  </v-col>
                  <span class="pt-3 font-16 text-000000">/</span>
                  <v-col cols="auto" class="pl-0">
                    <span v-if="data.oral_health_screening.brushing_teeth.answer_title != 'ไม่แปรง'" class="font-16 text-000000">{{ data.oral_health_screening.using_toothpaste == true ? 'ใช้ยาสีฟัน' : 'ไม่ใช้ยาสีฟัน' || '-' }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" xl="6" lg="6">
                <v-row>
                  <v-col cols="auto" class="pr-0" :class="x_mobile ? 'pb-0' : ''">
                    <span class="mr-2 font-16 text-000000">1.2) การทำความสะอาดซอกฟัน : </span>
                  </v-col>
                  <v-col cols="auto" class="d-flex pl-0">
                    <span class="font-16 text-000000">{{ data.oral_health_screening.cleaning_teeth.answer_title || '-' }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="box">
            <v-row>
              <v-col cols="12" sm="5" md="5" xl="5" lg="5" class="pb-0">
                <span class="font-16 text-000000 w-600"><u>การคัดกรองสุขภาวะทางตา : สุขภาพตา</u></span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0">
                <span class="font-16 text-000000">1.นับนิ้วในระยะ 3 เมตรได้ถูกต้อง &lt; 3 ใน 4 ครั้ง : </span>
                <span class="mr-2 font-16 text-000000">{{ data.eye_health_screening.count_fingers_3m.answer_title +' '+ data.eye_health_screening.count_fingers_3m.answer_code || '-' }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0">
                <span class="font-16 text-000000">2.อ่านหนังสือพิมพ์หน้าหนึ่ง ในระยะ 1 ฟุตไม่ได้ : </span>
                <span class="mr-2 font-16 text-000000">{{ data.eye_health_screening.read_newspaper_1ft.answer_title +' '+ data.eye_health_screening.read_newspaper_1ft.answer_code || '-' }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0">
                <span class="font-16 text-000000">3.ปิดตาดูทีละข้าง (ตามัวคล้ายหมอกบัง) ต้อกระจก : </span>
                <span class="mr-2 font-16 text-000000">{{ data.eye_health_screening.blurred_vision.answer_title +' '+ data.eye_health_screening.blurred_vision.answer_code || '-' }}</span>
                <span class="mr-2 font-16 text-000000" v-if="data.eye_health_screening.blurred_vision.left_eye == true">ข้างซ้าย</span>
                <span class="mr-2 font-16 text-000000" v-if="data.eye_health_screening.blurred_vision.left_eye == true && data.eye_health_screening.blurred_vision.right_eye == true">/</span>
                <span class="mr-2 font-16 text-000000" v-if="data.eye_health_screening.blurred_vision.right_eye == true">ข้างขวา</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0">
                <span class="font-16 text-000000">4.ปิดตาดูทีละข้าง (มองชัดแค่ตรงกลาง) ต้อหิน : </span>
                <span class="mr-2 font-16 text-000000">{{ data.eye_health_screening.clearly_middle.answer_title +' '+ data.eye_health_screening.clearly_middle.answer_code || '-' }}</span>
                <span class="mr-2 font-16 text-000000" v-if="data.eye_health_screening.clearly_middle.left_eye == true">ข้างซ้าย</span>
                <span class="mr-2 font-16 text-000000" v-if="data.eye_health_screening.clearly_middle.left_eye == true && data.eye_health_screening.clearly_middle.right_eye == true">/</span>
                <span class="mr-2 font-16 text-000000" v-if="data.eye_health_screening.clearly_middle.right_eye == true">ข้างขวา</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="font-16 text-000000">5.ปิดตาดูทีละข้าง (มองจุดดำกลางภาพ/บิดเบี้ยว) จอตาเสื่อม : </span>
                <span class="mr-2 font-16 text-000000">{{ data.eye_health_screening.black_spot_center.answer_title +' '+ data.eye_health_screening.black_spot_center.answer_code || '-' }}</span>
                <span class="mr-2 font-16 text-000000" v-if="data.eye_health_screening.black_spot_center.left_eye == true">ข้างซ้าย</span>
                <span class="mr-2 font-16 text-000000" v-if="data.eye_health_screening.black_spot_center.left_eye == true && data.eye_health_screening.black_spot_center.right_eye == true">/</span>
                <span class="mr-2 font-16 text-000000" v-if="data.eye_health_screening.black_spot_center.right_eye == true">ข้างขวา</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xl="6" lg="6" class="box">
            <v-row>
              <v-col cols="auto" class="pr-0">
                <span class="mr-2 font-16 text-000000"><u class="w-600">การคัดกรองโรคข้อเข่าเสื่อม : </u>{{ data.screening_osteoarthritis.answer_title || '-' }}</span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" xl="6" lg="6" class="box">
            <v-row>
              <v-col cols="auto" class="pr-0">
                <span class="mr-2 font-16 text-000000"><u class="w-600">การคัดกรองภาวะกลั้นปัสสาวะ :</u> ปัสสาวะเล็ด/ราดจนทำให้ใช้ชีวิตลำบาก : {{ data.screening_urinary_incontinence.answer_title || '-' }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="box">
            <v-row>
              <v-col cols="auto" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000"><u class="w-600">การคัดกรองภาวะหกล้ม (TUGT) : </u>6 เดือนที่ผ่านมาเคยหกล้ม : {{ data.screening_falls.fallen_6months_ago.answer_title || '-' }}</span>
              </v-col>
              <v-col cols="12">
                <v-row class="baseline">
                  <v-col cols="auto" class="pr-0 pb-0">
                    <span class="mr-2 font-16 text-000000">จับเวลาได้ : </span>
                  </v-col>
                  <v-col xl="auto" lg="auto" class="pl-0 pb-0 d-flex" :class="x_mobile || tablet ? '' : 'pr-0'">
                    <v-row>
                      <v-col cols="auto" class="d-flex baseline" :class="x_mobile ? '' : 'pr-0'">
                        <span class="mr-2 font-16 text-000000">{{ data.screening_falls.count_time.minute || '-' }} นาที</span>
                      </v-col>
                      <v-col cols="auto" class="d-flex baseline">
                        <span class="mr-2 font-16 text-000000">{{ data.screening_falls.count_time.second || '-' }} วินาที</span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="auto" class="pb-0 d-flex">
                    <v-row class="baseline">
                      <v-col cols="12" sm="auto" md="auto" xl="auto" lg="auto" :class="!x_mobile ? 'pr-0' : ''">
                        <span class="mr-2 font-16 text-000000">({{ data.screening_falls.walking.answer_title || '-' }})</span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <span class="font-16 text-000000">(ให้ผู้สูงอายุเดินจากเก้าอี้ที่นั่ง วัดระยะ 3 เมตร เดินเป็นเส้นตรง (ใช้อุปกรณ์ช่วยเดินที่ใช้ประจำได้) ไป-กลับ)</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="box">
            <v-row>
              <v-col cols="auto" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000 w-600"><u>การประเมินความสามารถในการทำกิจกรรมประจำวัน : ADL</u></span>
              </v-col>
            </v-row>
            <!-- 1 -->
            <v-row>
              <v-col cols="12" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000">1.กินอาหาร เมื่อเตรียมไว้ตรงหน้า : {{ data.daily_activities.food_in_front.answer_title || '-' }}</span>
              </v-col>
            </v-row>
            <!-- 2 -->
            <v-row>
              <v-col cols="12" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000">2.ล้างหน้า หวีผม แปรงฟัน โกนหนวด : {{ data.daily_activities.clean_face.answer_title || '-' }}</span>
              </v-col>
            </v-row>
            <!-- 3 -->
            <v-row>
              <v-col cols="12" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000">3.ลุกนั่งจากที่นอน/จากเตียงไปเก้าอี้ : {{ data.daily_activities.wake_from_bed.answer_title || '-' }}</span>
              </v-col>
            </v-row>
            <!-- 4 -->
            <v-row>
              <v-col cols="12" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000">4.การใช้ห้องน้ำ : {{ data.daily_activities.using_bathroom.answer_title || '-' }}</span>
              </v-col>
            </v-row>
            <!-- 5 -->
            <v-row>
              <v-col cols="12" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000">5.การเคลื่อนที่ภายในห้อง/บ้าน : {{ data.daily_activities.movement.answer_title || '-' }}</span>
              </v-col>
            </v-row>
            <!-- 6 -->
            <v-row>
              <v-col cols="12" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000">6.การสวมใส่เสื้อผ้า : {{ data.daily_activities.wearing_clothes.answer_title || '-' }}</span>
              </v-col>
            </v-row>
            <!-- 7 -->
            <v-row>
              <v-col cols="12" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000">7.การขึ้นลงบันได 1 ขั้น : {{ data.daily_activities.stairs_1step.answer_title || '-' }}</span>
              </v-col>
            </v-row>
            <!-- 8 -->
            <v-row>
              <v-col cols="12" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000">8.การอาบน้ำ : {{ data.daily_activities.shower.answer_title || '-' }}</span>
              </v-col>
            </v-row>
            <!-- 9 -->
            <v-row>
              <v-col cols="12" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000">9.การกลั้นการถ่ายอุจจาระ : {{ data.daily_activities.suppress_defecation.answer_title || '-' }}</span>
              </v-col>
            </v-row>
            <!-- 10 -->
            <v-row>
              <v-col cols="12" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000">10.การกลั้นปัสสาวะ : {{ data.daily_activities.holding_urine.answer_title || '-' }}</span>
              </v-col>
            </v-row>
            <!-- total -->
            <v-row>
              <v-col cols="auto" class="d-flex baseline">
                <span class="mr-2 font-16 text-000000">รวม : {{ data.daily_activities.total_score || '-' }} คะแนน</span>
              </v-col>
              <v-col class="pr-0 baseline d-flex">
                <span class="mr-2 font-16 text-000000">({{ data.daily_activities.group_type.answer_title || '-' }})</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="box">
            <v-row>
              <v-col cols="auto" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000 w-600"><u>การคัดกรองสมรรถภาพสมอง ด้วย Mini-Cog</u></span>
              </v-col>
              <v-col cols="12" xl="auto" lg="auto" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000">เกณฑ์การประเมิน คะแนนเต็ม 5 คะแนน</span>
              </v-col>
              <v-col cols="12" xl="auto" lg="auto" class="pr-0 pb-0">
                <span class="mr-2 font-16 text-000000">({{ data.brain_performance.answer_title || '-' }})</span>
              </v-col>
            </v-row>
            <v-row style="align-items: center !important;">
              <v-col cols="12" xl="3" lg="3" :class="x_mobile || tablet ? 'pb-0' : 'pb-4'" style="text-align: -webkit-center !important;">
                <div class="circle">
                  <v-img :src="data.brain_performance.clock_img"/>
                </div>
              </v-col>
              <v-col :class="x_mobile || tablet ? '' : 'pr-0'">
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <span class="mr-2 font-16 text-000000 w-600">แนวทางปฏิบัติ</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <span class="mr-2 font-16 text-000000">1. จนท. บอก 3 คำ ให้กับผู้ทดสอบจำและพูดตาม “ <u>หลานสาว, สวรรค์, ภูเขา</u> ” เดี่ยวจะกลับมาถามซ้ำ</span>
                  </v-col>
                  <v-col cols="12" class="d-flex pb-0">
                    <v-row class="baseline">
                      <v-col cols="auto" :class="x_mobile ? '' : 'pr-0'">
                        <span class="mr-2 font-16 text-000000">2. ให้ผู้ทดสอบวาดรูปนาฬิกาโดยใส่ “ <u>ตัวเลขและเข็มนาฬิกาที่เวลา 11.10 น.</u> ” รวม : {{ data.brain_performance.score_drawing_clock || '-' }} คะแนน</span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="pb-0">
                    <span class="mr-2 font-16 text-000000">(ทำได้ทั้งสอง = 2 คะแนน / ทำอย่างใดอย่างหนึ่ง = 0 คะแนน)</span>
                  </v-col>
                  <v-col cols="12" class="d-flex">
                    <v-row class="baseline">
                      <v-col cols="auto" :class="x_mobile ? '' : 'pr-0'">
                        <span class="mr-2 font-16 text-000000">3. จนท. ถาม ผู้ทดสอบ 3 คำ ที่ให้จำ มีอะไรบ้าง (คำละ 1 คะแนน) รวม : {{ data.brain_performance.score_drawing_clock || '-' }} คะแนน</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="status !== 'see' && status !== 'detail'">
        <v-row class="px-5">
          <v-spacer></v-spacer>
          <v-col cols="6" xl="2" lg="3">
            <v-btn block rounded color="#00A99D" depressed outlined @click="saveForm('draft')">บันทึกฉบับร่าง</v-btn>
          </v-col>
          <v-col cols="6" xl="2" lg="3">
            <!-- <v-btn block rounded color="#00A99D" depressed :disabled="valid == false" class="btn-disabled" @click="saveForm(data, 'finish')">บันทึก</v-btn> -->
            <v-btn block rounded color="#00A99D" depressed dark @click="saveForm('finish')">บันทึก</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import functioncryto from "@/services/encrypt.js";

export default {
  data() {
    return {
      activePicker: null,
      dialog: false,
      item: {},
      value: {},
      status: '',
      day_menu: false,
      day_menu2: false,
      day_menu3: false,
      dateNow: moment().format("YYYY-MM-DD"),
      mask_id: 'X-XXXX-X####-##-#',
      mask_mobile1: '###-###-####',
      mask_mobile2: '#-####-####',
      minute: [],
      second: [],
      list: [],
      list2: [],
      isWrite: false,
      edit: false,
      splitID: '',
      splitMobile: '',
      cardnum: '',
      fullname_status: null,
      set_province: [],
      set_amphoe: [],
      set_tambon: [],
      data: {
        cid: '',
        id_card_num: '',
        community_name: '',
        house_no: '',
        data_addressable: {
          house_no: '',
          moo_no: '',
          soi: '',
          province: '',
          amphur: '',
          tambon: '',
          zipcode: ''
        },
        fullname: '',
        gender: '',
        birth_date: '',
        age: '',
        weight: '',
        height: '',
        around_waist: '',
        mobile: '',
        personal_diseases: '',
        treatment_location: '',
        risk: {
          status: null,
          answer_title: ''
        },
        caretaker_name: '',
        family_history: {
          status: null,
          answer_title: ''
        },
        screening_risk_over35: {
          BP1: '',
          BP2: '',
          CVD_Risk: '',
          DTX: '',
          normality: {
            status: null,
            answer_title: '',
          },
          smoking: {
            status: null,
            answer_title: '',
          },
          alcohol: {
            status: null,
            answer_title: '',
          },
        },
        information_depression: {
          status: null,
          answer_title: '',
          subanswer_title_1: {
            status: null,
            answer_title: '',
          },
          subanswer_title_2: {
            status: null,
            answer_title: '',
          },
        },
        cervical_cancer: {
          status: null,
          answer_title: '',
          inspection_location: '',
          last_inspection_result: '',
        },
        colon_cancer: {
          inspection_date: '',
          inspection_location: '',
          last_inspection_result: '',
        },
        breast_cancer: {
          Inspector: null,
          Inspector_title: '',
          inspection_date: '',
          inspection_location: '',
          last_inspection_result: '',
        },
        oral_health_screening: {
          decency: null,
          decency_title: '',
          brushing_teeth: {
            status: null,
            answer_title: '',
            time: ''
          },
          using_toothpaste: null,
          cleaning_teeth: {
            status: null,
            answer_title: ''
          }
        },
        eye_health_screening: {
          count_fingers_3m: {
            status: null,
            answer_title: '',
            answer_code: '',
          },
          read_newspaper_1ft: {
            status: null,
            answer_title: '',
            answer_code: '',
          },
          blurred_vision: {
            status: null,
            answer_title: '',
            answer_code: '',
            left_eye: null,
            right_eye: null,
          },
          clearly_middle: {
            status: null,
            answer_title: '',
            answer_code: '',
            left_eye: null,
            right_eye: null,
          },
          black_spot_center: {
            status: null,
            answer_title: '',
            answer_code: '',
            left_eye: null,
            right_eye: null,
          },
        },
        screening_osteoarthritis: {
          status: null,
          answer_title: '',
        },
        screening_urinary_incontinence: {
          status: null,
          answer_title: '',
        },
        screening_falls: {
          fallen_6months_ago: {
            status: null,
            answer_title: '',
          },
          count_time: {
            minute: '',
            second: ''
          },
          walking: {
            status: null,
            answer_title: '',
          },
        },
        daily_activities: {
          food_in_front: {
            score: null,
            answer_title: '',
          },
          clean_face: {
            score: null,
            answer_title: '',
          },
          wake_from_bed: {
            score: null,
            answer_title: '',
          },
          using_bathroom: {
            score: null,
            answer_title: '',
          },
          movement: {
            score: null,
            answer_title: '',
          },
          wearing_clothes: {
            score: null,
            answer_title: '',
          },
          stairs_1step: {
            score: null,
            answer_title: '',
          },
          shower: {
            score: null,
            answer_title: '',
          },
          suppress_defecation: {
            score: null,
            answer_title: '',
          },
          holding_urine: {
            score: null,
            answer_title: '',
          },
          total_score: 0,
          group_type: {
            status: null,
            answer_title: ''
          },
        },
        brain_performance: {
          clock_img: '',
          score_drawing_clock: 0, //ให้ผู้ทดสอบวาดรูปนาฬิกาโดยใส่ “ตัวเลขและเข็มนาฬิกาที่เวลา11.10 น.”
          score_3words: 0, //จนท. ถามผู้ทดสอบคำ 3 ค า ที่ให้จำมีอะไรบ้าง (คำละ 1 คะแนน)
          status: 0,
          answer_title: '',
          file_id_clock_image: '',
        },
      },
      rules_input: [(v) => !!v || "กรุณากรอกข้อมูล"],
      rules_input_num: [(v) => !!v || "กรุณากรอกข้อมูล", (v) => /^([0-9])+$/.test(v) || "กรอกได้เฉพาะตัวเลข"],
      rules_select: [(v) => !!v || "กรุณาเลือกข้อมูล"],
      status_depress: [0, 0],
      clock_image_HTML: '',
    }
  },
  watch: {
    day_menu (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
    day_menu2 (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
    day_menu3 (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
  },
  computed: {
    x_mobile() {
      if (this.$vuetify.breakpoint.width < 416) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (this.$vuetify.breakpoint.width > 415 && this.$vuetify.breakpoint.width < 1264) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    check_information_depression(title) {
      if(title == 'subanswer_title_1') {
        if(this.data.information_depression.subanswer_title_1.status == '0') {
          this.status_depress[0] = 0
        } else if(this.data.information_depression.subanswer_title_1.status == '1') {
          this.status_depress[0] = 1
        }
      } else if(title == 'subanswer_title_2') {
        if(this.data.information_depression.subanswer_title_2.status == '0') {
          this.status_depress[1] = 0
        } else if(this.data.information_depression.subanswer_title_2.status == '1') {
          this.status_depress[1] = 1
        }
      }

      if(this.status_depress[0] == 1 || this.status_depress[1] == 1) {
        this.data.information_depression.status = '1'
      } else if(this.status_depress[0] == 0 && this.status_depress[1] == 0) {
        this.data.information_depression.status = '0'
      }
    },
    async getProvince() {
      try {
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/province`).then((res) => {
          if (res.data.result == "success") {
            this.set_province = res.data.data;
          } 
        });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    async getAmphoe() {
      try {
        let province = this.data.data_addressable.province
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/province/amphoe/${province}`).then((res) => {
          if (res.data.result == "success") {
            this.set_amphoe = res.data.data;
            this.data.data_addressable.zipcode = "";
            this.data.data_addressable.amphur = ""
            this.data.data_addressable.tambon = ""
          }
        });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    async getTambon() {
      try {
        let province = this.data.data_addressable.province
        let amphur = this.data.data_addressable.amphur
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/province/amphoe/tambon/${province}/${amphur}`).then(async (res) => {
          if (res.data.result == "success") {
            this.set_tambon = res.data.data;
            this.data.data_addressable.zipcode = ""
            await this.getPostal(this.data.data_addressable.tambon);
          }
        });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    async getPostal(e) {
      var postal = await this.set_tambon.find((ele) => {
        return ele.tambon === e;
      });
      
      if (postal !== undefined) {
        this.data.data_addressable.zipcode = postal.zipcode;
      } else {
        this.data.data_addressable.zipcode = "";
      }
    },
    async openDialog(item, value, status) {
      console.log('item', item);
      // console.log('status', status);
      this.status = status
      this.item = item
      this.value = value
      this.splitID = ''
      this.splitMobile = ''
      
      for(var i=0; i<=60; i++) {
        if(i < 10) {
          this.minute.push('0'+i)
          this.second.push('0'+i)
        } else {
          this.minute.push(i.toString())
          this.second.push(i.toString())
        }
      }

      if (status !== 'see') {
        await this.getDataForm()
      }

      this.mask_id = 'X-XXXX-X####-##-#'
      this.mask_mobile1 = '###-###-####'
      this.mask_mobile2 = '#-####-####'
      this.isWrite = false

      await this.getProvince();

      this.dialog = true
    },
    closeDialog() {
      this.clearMask()
      this.clearData()
      if (this.status !== 'see' && this.status !== 'detail') {
        if(this.edit == true) {
          this.clearSign()
        }
        this.$refs.form.resetValidation();
      }
      this.dialog = false
    },
    displayDate() {
      var year1 = ""
      var year2 = ""
      if (!this.data.birth_date) return;
        year1 = moment(this.data.birth_date).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return moment(this.data.birth_date).locale("th").format("DD/MM/" + year2)
    },
    clearDaySelect() {
      this.data.birth_date = null;
      this.day_menu = false;
    },
    calculateAge(date = "") {
      const y = Math.floor(moment.duration(moment().diff(date)).asYears());
      this.data.age = y
      if (isNaN(y)) return 0;
      return `${y}`;
    },
    displayDate2() {
      var year1 = ""
      var year2 = ""
      if (!this.data.colon_cancer.inspection_date) return;
        year1 = moment(this.data.colon_cancer.inspection_date).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return moment(this.data.colon_cancer.inspection_date).locale("th").format("DD/MM/" + year2)
    },
    clearDaySelect3() {
      this.data.colon_cancer.inspection_date = null;
      this.day_menu2 = false;
    },
    displayDate3() {
      var year1 = ""
      var year2 = ""
      if (!this.data.breast_cancer.inspection_date) return;
        year1 = moment(this.data.breast_cancer.inspection_date).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return moment(this.data.breast_cancer.inspection_date).locale("th").format("DD/MM/" + year2)
    },
    clearDaySelect2() {
      this.data.breast_cancer.inspection_date = null;
      this.day_menu3 = false;
    },
    clearMask() {
      this.mask_id = ''
      this.mask_mobile1 = ''
      this.mask_mobile2 = ''
    },
    clearData() {
      this.set_province = []
      this.set_amphoe = []
      this.set_tambon = []
      this.data = {
        cid: '',
        id_card_num: '',
        community_name: '',
        house_no: '',
        data_addressable: {
          house_no: '',
          moo_no: '',
          soi: '',
          province: '',
          amphur: '',
          tambon: '',
          zipcode: ''
        },
        cardnum: '',
        fullname: '',
        gender: '',
        birth_date: '',
        age: '',
        weight: '',
        height: '',
        around_waist: '',
        mobile: '',
        personal_diseases: '',
        treatment_location: '',
        risk: {
          status: null,
          answer_title: ''
        },
        caretaker_name: '',
        family_history: {
          status: null,
          answer_title: ''
        },
        screening_risk_over35: {
          BP1: '',
          BP2: '',
          CVD_Risk: '',
          DTX: '',
          normality: {
            status: null,
            answer_title: '',
          },
          smoking: {
            status: null,
            answer_title: '',
          },
          alcohol: {
            status: null,
            answer_title: '',
          },
        },
        information_depression: {
          status: null,
          answer_title: '',
          subanswer_title_1: {
            status: null,
            answer_title: '',
          },
          subanswer_title_2: {
            status: null,
            answer_title: '',
          },
        },
        cervical_cancer: {
          status: null,
          answer_title: '',
          inspection_location: '',
          last_inspection_result: '',
        },
        colon_cancer: {
          inspection_date: '',
          inspection_location: '',
          last_inspection_result: '',
        },
        breast_cancer: {
          Inspector: null,
          Inspector_title: '',
          inspection_date: '',
          inspection_location: '',
          last_inspection_result: '',
        },
        oral_health_screening: {
          decency: null,
          decency_title: '',
          brushing_teeth: {
            status: null,
            answer_title: '',
            time: ''
          },
          using_toothpaste: null,
          cleaning_teeth: {
            status: null,
            answer_title: ''
          }
        },
        eye_health_screening: {
          count_fingers_3m: {
            status: null,
            answer_title: '',
            answer_code: '',
          },
          read_newspaper_1ft: {
            status: null,
            answer_title: '',
            answer_code: '',
          },
          blurred_vision: {
            status: null,
            answer_title: '',
            answer_code: '',
            left_eye: null,
            right_eye: null,
          },
          clearly_middle: {
            status: null,
            answer_title: '',
            answer_code: '',
            left_eye: null,
            right_eye: null,
          },
          black_spot_center: {
            status: null,
            answer_title: '',
            answer_code: '',
            left_eye: null,
            right_eye: null,
          },
        },
        screening_osteoarthritis: {
          status: null,
          answer_title: '',
        },
        screening_urinary_incontinence: {
          status: null,
          answer_title: '',
        },
        screening_falls: {
          fallen_6months_ago: {
            status: null,
            answer_title: '',
          },
          count_time: {
            minute: '',
            second: ''
          },
          walking: {
            status: null,
            answer_title: '',
          },
        },
        daily_activities: {
          food_in_front: {
            score: null,
            answer_title: '',
          },
          clean_face: {
            score: null,
            answer_title: '',
          },
          wake_from_bed: {
            score: null,
            answer_title: '',
          },
          using_bathroom: {
            score: null,
            answer_title: '',
          },
          movement: {
            score: null,
            answer_title: '',
          },
          wearing_clothes: {
            score: null,
            answer_title: '',
          },
          stairs_1step: {
            score: null,
            answer_title: '',
          },
          shower: {
            score: null,
            answer_title: '',
          },
          suppress_defecation: {
            score: null,
            answer_title: '',
          },
          holding_urine: {
            score: null,
            answer_title: '',
          },
          total_score: 0,
          group_type: {
            status: null,
            answer_title: ''
          },
        },
        brain_performance: {
          clock_img: '',
          score_drawing_clock: 0, //ให้ผู้ทดสอบวาดรูปนาฬิกาโดยใส่ “ตัวเลขและเข็มนาฬิกาที่เวลา11.10 น.”
          score_3words: 0, //จนท. ถามผู้ทดสอบคำ 3 ค า ที่ให้จำมีอะไรบ้าง (คำละ 1 คะแนน)
          status: 0,
          answer_title: '',
          file_id_clock_image: '',
        }
      }
      this.minute = []
      this.second = []
      this.list = []
      this.list2 = []
      this.item = {}
      this.value = {}
      this.splitID = ''
      this.splitMobile = ''
      this.clock_image_HTML = ''
    },
    calScore(title) {
      var total = 0
      if(title == 'food_in_front') {
        if(this.data.daily_activities.food_in_front.score != null) {
          this.list[0] = parseInt(this.data.daily_activities.food_in_front.score)
        } else {
          this.list[0] = 0
        }
      } else if(title == 'clean_face') {
        if(this.data.daily_activities.clean_face.score != null) {
          this.list[1] = parseInt(this.data.daily_activities.clean_face.score)
        } else {
          this.list[1] = 0
        }
      } else if(title == 'wake_from_bed') {
        if(this.data.daily_activities.wake_from_bed.score != null) {
          this.list[2] = parseInt(this.data.daily_activities.wake_from_bed.score)
        } else {
          this.list[2] = 0
        }
      } else if(title == 'using_bathroom') {
        if(this.data.daily_activities.using_bathroom.score != null) {
          this.list[3] = parseInt(this.data.daily_activities.using_bathroom.score)
        } else {
          this.list[3] = 0
        }
      } else if(title == 'movement') {
        if(this.data.daily_activities.movement.score != null) {
          this.list[4] = parseInt(this.data.daily_activities.movement.score)
        } else {
          this.list[4] = 0
        }
      } else if(title == 'wearing_clothes') {
        if(this.data.daily_activities.wearing_clothes.score != null) {
          this.list[5] = parseInt(this.data.daily_activities.wearing_clothes.score)
        } else {
          this.list[5] = 0
        }
      } else if(title == 'stairs_1step') {
        if(this.data.daily_activities.stairs_1step.score != null) {
          this.list[6] = parseInt(this.data.daily_activities.stairs_1step.score)
        } else {
          this.list[6] = 0
        }
      } else if(title == 'shower') {
        if(this.data.daily_activities.shower.score != null) {
          this.list[7] = parseInt(this.data.daily_activities.shower.score)
        } else {
          this.list[7] = 0
        }
      } else if(title == 'suppress_defecation') {
        if(this.data.daily_activities.suppress_defecation.score != null) {
          this.list[8] = parseInt(this.data.daily_activities.suppress_defecation.score)
        } else {
          this.list[8] = 0
        }
      } else if(title == 'holding_urine') {
        if(this.data.daily_activities.holding_urine.score != null) {
          this.list[9] = parseInt(this.data.daily_activities.holding_urine.score)
        } else {
          this.list[9] = 0
        }
      }

      for(var x in this.list) {
        total += this.list[x]
      }

      this.data.daily_activities.total_score = total

      if(this.data.daily_activities.total_score <= 4) {
        this.data.daily_activities.group_type.status = '2'
        this.data.daily_activities.group_type.answer_title = 'กลุ่ม 3 ได้ <=4 คะแนน 1B1282'
      } else if(this.data.daily_activities.total_score >= 5 && this.data.daily_activities.total_score <= 11) {
        this.data.daily_activities.group_type.status = '1'
        this.data.daily_activities.group_type.answer_title = 'กลุ่ม 2 ได้ 5-11 คะแนน 1B1281'
      } else if(this.data.daily_activities.total_score >= 12) {
        this.data.daily_activities.group_type.status = '0'
        this.data.daily_activities.group_type.answer_title = 'กลุ่ม 1 ได้ >= 12 คะแนน 1B1280'
      }
    },
    calScore2(title) {
      var total2 = 0
      if(title == 'score_drawing_clock') {
        if(this.data.brain_performance.score_drawing_clock != null) {
          this.list2[0] = parseInt(this.data.brain_performance.score_drawing_clock)
        } else {
          this.list2[0] = 0
        }
      } else if(title == 'score_3words') {
        if(this.data.brain_performance.score_3words != null) {
          this.list2[1] = parseInt(this.data.brain_performance.score_3words)
        } else {
          this.list2[1] = 0
        }
      }

      for(var y in this.list2) {
        total2 += this.list2[y]
      }

      if(total2 <= 3) {
        this.data.brain_performance.status = '0'
        this.data.brain_performance.answer_title = '<= 3 คะแนน มีภาวะบกพร่องทางการรู้คิด ส่งต่อ คลินิกผู้สูงอายุ'
      } else if(total2 >= 4) {
        this.data.brain_performance.status = '1'
        this.data.brain_performance.answer_title = '4 คะแนนขึ้นไป ภาวะรู้สึกปกติ'
      }
    },
    onEnd() {
      const { isEmpty } = this.$refs.signaturePad.saveSignature();
      if (isEmpty === true) {
        this.isWrite = false;
      } else {
        this.isWrite = true;
      }
    },
    clearSign() {
      this.$refs.signaturePad.clearSignature();
      this.isWrite = false;
    },
    clearBack() {
      const { isEmpty } = this.$refs.signaturePad.saveSignature();
      if (isEmpty === true) {
        this.isWrite = false;
      } else {
        this.$refs.signaturePad.undoSignature();
      }
    },
    saveForm(status) {
      this.$swal({
        title: "<span style='color: #000000;font-size: 20px;font-family: Sarabun;font-weight: 700;'>ท่านต้องการยืนยันบันทึกข้อมูลนี้ใช่หรือไม่ ?</span>",
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText:
          "<span style='color: #F5222D;font-size: 16px;font-family: Sarabun, sans-serif'>ยกเลิก</span>",
        cancelButtonColor: "#FFFFFF",
        showConfirmButton: true,
        confirmButtonText:
          "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
        confirmButtonColor: "#00A99D",
        allowOutsideClick: false,
      }).then(async(result) => {
        if (result.isConfirmed) {
          // console.log('data : ', data);
          // console.log('type : ', type);
          // if (!this.$refs.save_form.validate() && status == 'finish') {
          //   this.$swal({
          //     title:
          //       "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>กรุณากรอกข้อมูลให้ครบถ้วน</span>",
          //     icon: "error",
          //     showCloseButton: false,
          //     showConfirmButton: false,
          //     background: "white",
          //     timer: 3000,
          //   });
          // } else {

          try {
            var params = new URLSearchParams()
            params.append('biz_id', sessionStorage.getItem('biz_id'))
            params.append('appointment_id', this.item.appointment_id)
            params.append('template_id', this.value.template_id)
            params.append('actions_type', status)
            params.append('account_id', sessionStorage.getItem("account_id"))

            if(this.edit == true && this.isWrite == true) {
              const img = this.$refs.signaturePad.saveSignature()
              // console.log(img);
              if(img.isEmpty == false) {
                this.data.brain_performance.clock_img = img.data
              } else if(img.isEmpty == true) {
                this.data.brain_performance.clock_img = ''
              }
            }

            if(this.data.house_no == '') {
              this.data.house_no = "บ้านเลขที่ " + (this.data.data_addressable.house_no || '-') +
                                   " หมู่ " + (this.data.data_addressable.moo_no || '-') +
                                   " ถนน/ซอย" + (this.data.data_addressable.soi || '-') +
                                   " ตำบล/แขวง" + (this.data.data_addressable.tambon || '-') +
                                   " อำเภอ/เขต" + (this.data.data_addressable.amphur || '-') +
                                   " จังหวัด" + (this.data.data_addressable.province || '-') +
                                   " รหัสไปรษณีย์ " + (this.data.data_addressable.zipcode || '-')
            }

            await this.splitDat2('mobile')

            this.splitID = ''
            await this.splitDat()
            this.data.cid = functioncryto.encrypt(this.splitID)

            // console.log('data', this.data)

            await this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/update_template_home_visit?${params}`, 
              {
                formElderlyPerson: this.data
              }
            ).then((res) => {
              // console.log('res444444444444',res);
              if (res.data.result == "success" && res.data.code == 200) {
                this.$swal({
                  icon: "success",
                  title: "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลสำเร็จ</span>",
                  showConfirmButton: false,
                }).then(() => {
                  this.closeDialog()
                  this.$emit("close");
                  this.$emit("status_type", this.status)
                })
              } else {
                this.$swal({
                  icon: "error",
                  title:"<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดพลาด</span>",
                  html: "<span style='color: black;font-size: 16px;font-family: Sarabun, sans-serif;'>เนื่องจาก " + res.data.message + "</span>",
                  showConfirmButton: false,
                }).then(() => {
                  this.closeDialog();
                  this.$emit("close");
                });
              }
            })
          } catch (err) {
            console.log(err);
          }
        }
      })
    },
    async getDataForm() {
      try {
        var params = new URLSearchParams()
        params.append('template_id', this.value.template_id)
        params.append('biz_id', sessionStorage.getItem('biz_id'))
        params.append('userqr_id', this.item.userqr_id || '')
         
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/get_home_visits_byid?${params}` ,
        ).then(async (res) => {
        console.log('get data',res);
          if (res.data.result == "success" && res.data.code == 200) {
            if ('formElderlyPerson' in res.data.data && res.data.data.formElderlyPerson !== null && res.data.data.formElderlyPerson !== '' && res.data.data.formElderlyPerson !== undefined) {
              this.data = res.data.data.formElderlyPerson
              
              this.data.house_no = 'info_address' in res.data.data && res.data.data.info_address !== '' && res.data.data.info_address !== null && res.data.data.info_address !== undefined ? res.data.data.info_address:''
              this.data.gender = 'gender' in res.data.data && res.data.data.gender !== '' && res.data.data.gender !== null && res.data.data.gender !== undefined ? res.data.data.gender:''
              this.data.birth_date = 'birth_date' in res.data.data && res.data.data.birth_date !== '' && res.data.data.birth_date !== null && res.data.data.birth_date !== undefined ? res.data.data.birth_date:''
              this.data.id_card_num = 'cid' in res.data.data && res.data.data.cid !== '' && res.data.data.cid !== null && res.data.data.cid !== undefined ? res.data.data.cid:''
              
              if(this.data.house_no == ''){
                this.data.data_addressable = {
                  house_no: 'houseNo' in res.data.data && res.data.data.houseNo !== '' && res.data.data.houseNo !== null && res.data.data.houseNo !== undefined ? res.data.data.houseNo:'',
                  moo_no: 'moo' in res.data.data && res.data.data.moo !== '' && res.data.data.moo !== null && res.data.data.moo !== undefined ? res.data.data.moo:'',
                  soi: 'soi' in res.data.data && res.data.data.soi !== '' && res.data.data.soi !== null && res.data.data.soi !== undefined ? res.data.data.soi:'',
                  province: 'province' in res.data.data && res.data.data.province !== '' && res.data.data.province !== null && res.data.data.province !== undefined ? res.data.data.province:'',
                  amphur: 'amphur' in res.data.data && res.data.data.amphur !== '' && res.data.data.amphur !== null && res.data.data.amphur !== undefined ? res.data.data.amphur:'',
                  tambon: 'tambon' in res.data.data && res.data.data.tambon !== '' && res.data.data.tambon !== null && res.data.data.tambon !== undefined ? res.data.data.tambon:'',
                  zipcode: 'zipcode' in res.data.data && res.data.data.zipcode !== '' && res.data.data.zipcode !== null && res.data.data.zipcode !== undefined ? res.data.data.moo:''
                }

              } else {
                this.data.data_addressable = {
                  house_no: '',
                  moo_no: '',
                  soi: '',
                  province: '',
                  amphur: '',
                  tambon: '',
                  zipcode: ''
                }
              }

              if (this.data.id_card_num !== '') {
                if(!this.data.id_card_num) {
                  this.data.cid = res.data.data.formElderlyPerson.cid
                } else {
                  this.data.cid = this.data.id_card_num
                }

                if(this.data.id_card_num != undefined && this.data.id_card_num != '') {
                  var cid = functioncryto.decrypt(this.data.id_card_num)
                  this.cardnum = cid.slice(0,1)+'-'+cid.slice(1,5)+'-'+cid.slice(5,10)+'-'+cid.slice(10,12)+'-'+cid.slice(12,13)
                } else {
                  this.cardnum = ''
                }
              } else if(this.data.id_card_num !== '') {
                this.cardnum = functioncryto.decrypt(this.data.id_card_num)
              } else {
                this.cardnum = ''
              }  

              if('fullname' in res.data.data && res.data.data.fullname !== '' && res.data.data.fullname !== null && res.data.data.fullname !== undefined) {
                this.data.fullname = res.data.data.fullname
                this.fullname_status = true
              } else {
                this.data.fullname = ''
                this.fullname_status = false
              }

              if ('mobile' in res.data.data && res.data.data.mobile !== '' && res.data.data.mobile !== null && res.data.data.mobile !== undefined) {
                if (res.data.data.mobile.length == 9) {
                  this.data.mobile = res.data.data.mobile.slice(0, 1) + '-' + res.data.data.mobile.slice(1, 5) + '-' + res.data.data.mobile.slice(5, 9)
                } else if (res.data.data.mobile.length == 10) {
                  this.data.mobile = res.data.data.mobile.slice(0, 3) + '-' + res.data.data.mobile.slice(3, 6) + '-' + res.data.data.mobile.slice(6, 10)
                }
              } else {
                this.data.mobile = ''
              }

              if ('formElderlyPerson' in res.data.data && 'brain_performance' in res.data.data.formElderlyPerson && 'file_id_clock_image' in res.data.data.formElderlyPerson.brain_performance && res.data.data.formElderlyPerson.brain_performance.file_id_clock_image !== '' && res.data.data.formElderlyPerson.brain_performance.file_id_clock_image !== null && res.data.data.formElderlyPerson.brain_performance.file_id_clock_image !== undefined) {
                this.data.brain_performance.file_id_clock_image = res.data.data.formElderlyPerson.brain_performance.file_id_clock_image
                await this.get_img_onebox(res.data.data.formElderlyPerson.brain_performance.file_id_clock_image)

                if (this.clock_image_HTML !== '') {
                  this.data.brain_performance.clock_img = this.clock_image_HTML
                }
              } else {
                this.data.brain_performance.file_id_clock_image = ''
                if ('formElderlyPerson' in res.data.data && 'brain_performance' in res.data.data.formElderlyPerson && 'clock_img' in res.data.data.formElderlyPerson.brain_performance && res.data.data.formElderlyPerson.brain_performance.clock_img !== '' && res.data.data.formElderlyPerson.brain_performance.clock_img !== null && res.data.data.formElderlyPerson.brain_performance.clock_img !== undefined) {
                  this.data.brain_performance.clock_img = res.data.data.formElderlyPerson.brain_performance.clock_img
                  this.edit = false
                } else {
                  this.data.brain_performance.clock_img = ''
                  this.edit = true
                }
              }
            } 
          }
        })
      } catch(error) {
        console.log('error',error);
      }
    },
    async get_img_onebox(item) {
      try {
        const params = new URLSearchParams();
        params.append("file_id", item);

        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/download_home_visit_one_box?${params}`).then((res) => {
          console.log('onebox', res);
          if (res.data.result == 'success' && res.data.code == 200) {
            if (res.data.data !== '' && res.data.data !== null && res.data.data !== undefined) {
              this.clock_image_HTML = 'data:image/png;base64,' + res.data.data
              this.edit = false
            } else {
              this.clock_image_HTML = ''
              this.edit = true
            }
          }
        })
      } catch(err) {
        console.log(err);
      }
    },
    formatDate(date) {
      var year1 = ""
      var year2 = ""
      year1 = moment(date).locale("th").format("YYYY")
      year2 = (parseInt(year1) + 543).toString()
      return moment(date).locale("th").format("DD/MM/" + year2)
    },
    splitDat() {
      if(this.cardnum.length == 17) {
        var x = this.cardnum.split('-')
        this.splitID = x[0]+x[1]+x[2]+x[3]+x[4]
      }
    },
    splitDat2(type) {
      if(type == 'mobile') {
        if(this.data.mobile.length == 11) {
          this.splitMobile = ''
          var x = this.data.mobile.split('-')
          this.splitMobile = x[0]+x[1]+x[2]
          this.data.mobile = this.splitMobile
        } else if(this.data.mobile.length == 12) {
          this.splitMobile = ''
          var z = this.data.mobile.split('-')
          this.splitMobile = z[0]+z[1]+z[2]
          this.data.mobile = this.splitMobile
        }
      }
    },
  }
}
</script>

<style scoped>
#bigSignature {
  min-width: 35vh !important;
  min-height: 41vh !important;
}
#bigSignature2 {
  min-width: 40vh !important;
  min-height: 43vh !important;
}
#signature {
  border: 2px solid #00A99D;
  min-width: 30vh !important;
  height: 35vh !important;
  border-radius: 50%;
}
.circle {
  width: 30vh;
  height: 30vh;
  border-radius: 50%;
  border: 2px solid #00A99D;
}
.baseline {
  align-items: baseline;
}
.box {
  border: 1px solid #333333;
  border-radius: 15px;
}
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
::v-deep .v-input--is-disabled > .v-input__control > .v-input__slot {
  background: #e8e9e9 !important;
}

::v-deep .theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: #313b41 !important;
}
</style>